export const en = {
    "socialMedia": {
        "facebook": "https://www.facebook.com/investturkey",
        "instagram": "https://www.instagram.com/investinturkiye_en",
        "linkedin": "https://www.linkedin.com/company/invest-in-turkey",
        "x": "https://twitter.com/InvestTurkey",
        "youtube": "https://www.youtube.com/c/InvestinT%C3%BCrkiye"
    },
    "heroSection": {
        "tagline": "2024-2028",
        "heading": "Foreign Direct Investment Strategy",
        "description": "This strategic roadmap aims to attract high-quality FDI investments that align with Türkiye's economic development goals amid a rapidly changing global economic environment."
    },
    "goals": [
        {
            "goalTag": "GOAL 1",
            "goalHeading": "Increasing Türkiye's FDI Share of Global FDI to 1.5%",
            "goalDescription": "The primary objective of the strategy is to boost Türkiye’s share in the global FDI market to 1.5% by 2028, through enhancing its performance in terms of the quality FDI profiles.",
            "goalNumber": "1.5",
            "mathSign": "%",
            "coverImage": {
                "src": "/images/fdi-strategy-cover_1.webp",
                "alt": "FDI Strategy Cover",
                "sizes": "(max-width: 479px) 76vw, (max-width: 767px) 320px, (max-width: 991px) 400px, 480px",
                "srcset": "/images/fdi-strategy-cover_1-p-500.png 500w, /images/fdi-strategy-cover_1fdi-strategy-cover.webp 800w, /images/fdi-strategy-cover_1fdi-strategy-cover.webp 1080w, /images/fdi-strategy-cover_1.webp 1600w"
            }
        },
        {
            "goalTag": "GOAL 2",
            "goalHeading": "Increasing Türkiye’s Regional Share in FDI Inflows to 12%",
            "goalDescription": "Türkiye aims to attract 12% of FDI inflows coming to Central and Eastern Europe, the Middle East, and North Africa regions (CEEMENA) by 2028.",
            "goalNumber": "12",
            "mathSign": "%",
        },
        {
            "goalTag": "GOAL 3",
            "goalHeading": "Achieving the 5-year Project Target for Each Quality FDI Profile",
            "goalNumber": "",
            "fdiCards": [
                {
                    "iconSrc": "/images/ClimateFDI.svg",
                    "title": "Climate FDI",
                    "factNumber": "120",
                    "description": "FDI Projects",
                    "backHeading": "Global Value Chains (GVCs) Are Being Reshaped",
                    "backDescription": "Geopolitical tensions, climate change...",
                    "backImageSrc": "/images/GlobalFDI-Trend-01.webp"
                },
                {
                    "iconSrc": "/images/DigitalFDI.svg",
                    "title": "Digital FDI",
                    "factNumber": "240",
                    "description": "FDI Projects",
                    "backHeading": "Global Value Chains (GVCs) Are Being Reshaped",
                    "backDescription": "Geopolitical tensions, climate change...",
                    "backImageSrc": "/images/GlobalFDI-Trend-01.webp"
                },
                {
                    "iconSrc": "/images/GVCRelatedFDI.svg",
                    "title": "Global Value Chain related FDI",
                    "factNumber": "360",
                    "description": "FDI Projects",
                    "backHeading": "Global Value Chains (GVCs) Are Being Reshaped",
                    "backDescription": "Geopolitical tensions, climate change...",
                    "backImageSrc": "/images/GlobalFDI-Trend-01.webp"
                },
                {
                    "iconSrc": "/images/HighENDServiceFDI.svg",
                    "title": "High-End Service FDI",
                    "factNumber": "270",
                    "description": "FDI Projects",
                    "backHeading": "Global Value Chains (GVCs) Are Being Reshaped",
                    "backDescription": "Geopolitical tensions, climate change...",
                    "backImageSrc": "/images/GlobalFDI-Trend-01.webp"
                },
                {
                    "iconSrc": "/images/HighQJobFDI.svg",
                    "title": "High-quality Job Generating FDI",
                    "factNumber": "360",
                    "description": "FDI Projects",
                    "backHeading": "Global Value Chains (GVCs) Are Being Reshaped",
                    "backDescription": "Geopolitical tensions, climate change...",
                    "backImageSrc": "/images/GlobalFDI-Trend-01.webp"
                },
                {
                    "iconSrc": "/images/Knowledge-IntensiveFDI.svg",
                    "title": "Knowledge Intensive FDI",
                    "factNumber": "300",
                    "description": "FDI Projects",
                    "backHeading": "Global Value Chains (GVCs) Are Being Reshaped",
                    "backDescription": "Geopolitical tensions, climate change...",
                    "backImageSrc": "/images/GlobalFDI-Trend-01.webp"
                }
            ]
        }
    ],
    "policyAreasSection": {
        "tagline": "FUNDAMENTAL PRINCIPLES",
        "heading": "Policy Areas",
        "cards": [
            {
                "id": "w-node-c915a300-f121-47df-acce-8975ad92eaee-ad92eaea",
                "href": "/action-plans#01",
                "title": "Investment Climate and Competitiveness"
            },
            {
                "id": "w-node-c915a300-f121-47df-acce-8975ad92eaef-ad92eaea",
                "href": "/action-plans#02",
                "title": "Green Transformation"
            },
            {
                "id": "w-node-c915a300-f121-47df-acce-8975ad92eaf3-ad92eaea",
                "href": "/action-plans#03",
                "title": "Digital Transformation"
            },
            {
                "id": "w-node-c915a300-f121-47df-acce-8975ad92eaf7-ad92eaea",
                "href": "/action-plans#04",
                "title": "Global Value Chains (GVCs)"
            },
            {
                "id": "w-node-c915a300-f121-47df-acce-8975ad92eafb-ad92eaea",
                "href": "/action-plans#05",
                "title": "Talent Pool"
            },
            {
                "id": "w-node-c915a300-f121-47df-acce-8975ad92eaff-ad92eaea",
                "href": "/action-plans#06",
                "title": "Communication & Promotion"
            }
        ]
    },
    "qualityFdiSlider": {
        "tagline": "FDI PROFILES",
        "heading": "Quality FDI for Türkiye",
        "slides": [
            {
                "id": "slide1",
                "frontImage": "/images/GlobalFDI-Trend-05_1.webp",
                "frontAlt": "Climate FDI Image",
                "frontNumber": "01",
                "frontTitle": "Climate FDI",
                "backTitle": "Climate FDI",
                "backBoldText": "FDI that supports the green transformation plays a crucial role in managing risks related to climate change and in accelerating the transition of economies towards a more sustainable structure.",
                "backImage": "/images/GlobalFDI-Trend-05_1.webp",
                "backRegularText": "Investments that support Türkiye’s climate change adaptation and mitigation efforts are considered as ‘Quality FDI’ projects. In the last 10 years, Türkiye has attracted 121 FDI projects under this profile.",
                "items": [
                    "Investments in energy production from renewable energy sources, particularly solar, wind, geothermal, and green hydrogen",
                    "Investments in technologies and products used generating green energy (solar panels, wind turbines, and engines etc.)",
                    "Investments fostering the e-mobility ecosystem in the country, including electric/hydrogen vehicles and components, batteries, etc.",
                    "Investments supporting the circular economy",
                    "Service investments in environmental technologies",
                    "Investments that develop and produce technologies/products to increase energy efficiency"
                ]
            },
            {
                "id": "slide2",
                "frontImage": "/images/GlobalFDI-Trend-08_1.webp",
                "frontAlt": "Digital FDI Image",
                "frontNumber": "02",
                "frontTitle": "Digital FDI",
                "backTitle": "Digital FDI",
                "backBoldText": "Investments supporting digital transformation enhance countries’ competitiveness in various aspects. Particularly, these investments contribute to green transformation and create high quality jobs.",
                "backImage": "/images/GlobalFDI-Trend-08_1.webp",
                "backRegularText": "Investments that support the digital transformation of the Turkish economy are considered as ‘Quality FDI’ projects for Türkiye. In the last 10 years, Türkiye has attracted 214 FDI projects under this profile.",
                "items": [
                    "Investments in semiconductor, electronic components, and information communication technologies (ICT) sectors",
                    "Investments in digital service channels (e-commerce, hyperscalers, platform economies, and sharing economies etc.)",
                    "Investments in software and gaming sectors",
                    "Investments that enhance the country’s telecommunication infrastructure (broadband, wired and wireless connections, data centers, internet infrastructure etc.)",
                    "Investments supporting the digitalization of traditional sectors (3D printing, big data analytics, blockchain, cloud computing, cybersecurity, internet of things, virtual/augmented reality technologies, etc.)",
                    "Investments in Edtech, HealthTech, FinTech, smart home applications, and wearable technologies"
                ]
            },
            {
                "id": "slide3",
                "frontImage": "/images/GlobalFDI-Trend-01.webp",
                "frontAlt": "Global Value Chain FDI Image",
                "frontNumber": "03",
                "frontTitle": "Global Value Chain (GVC) Related FDI",
                "backTitle": "Global Value Chain (GVC) Related FDI",
                "backBoldText": "Industries deeply embedded in global value chains have greater prospects for generating high-quality employment, enhancing efficiency, and boosting exports. Additionally, such investments promote the dissemination of knowledge and technology transfer via strong linkages with domestic firms.",
                "backImage": "/images/GlobalFDI-Trend-01.webp",
                "backRegularText": "Investments in production, R&D, and logistics that enhance Türkiye’s integration into GVCs are considered as ‘Quality FDI’ projects. In the last 10 years, Türkiye has attracted 539 FDI projects under this profile.",
                "items": [
                    "Investments in production, R&D, design, and innovation centers in medium high-tech (e.g., automotive, machinery, and chemicals) and high-tech sectors (e.g., pharmaceuticals, aviation, and semiconductors).",
                    "Investments in infrastructure that enhance the country’s transportation, logistics, distribution, and storage capacities.",
                    "Logistics, distribution, and storage center investments regardless of its sector.",
                    "Investments of multinationals for procurement offices established in Türkiye."
                ]
            },
            {
                "id": "slide4",
                "frontImage": "/images/knowledge-intensive-fdi.avif",
                "frontAlt": "Knowledge Intensive FDI Image",
                "frontNumber": "04",
                "frontTitle": "Knowledge Intensive FDI",
                "backTitle": "Knowledge Intensive FDI",
                "backBoldText": "Investments in high-tech and knowledge-intensive sectors elevate the technological level of the country’s goods and services exports, create high-paid jobs, and nourish the start-up ecosystem.",
                "backImage": "/images/knowledge-intensive-fdi.avif",
                "backRegularText": "Knowledge-intensive investments that enhance the value-addition in the country are considered as ‘Quality FDI’ projects for Türkiye. In the last 10 years, Türkiye has attracted 357 FDI projects under this profile.",
                "items": [
                    "Manufacturing investments in high-tech sectors with significant potential for job creation in STEM fields (aviation, ICT, medical devices, pharmaceuticals, semiconductors, software, and information technology services, aerospace and defense, etc.).",
                    "R&D, design, and innovation center investments regardless of its sector.",
                    "Investments improving the country’s information communication infrastructure (beyond 5G technologies, internet, data centers, wireless communication infrastructures, etc.).",
                    "Investments in creative industries (architectural design, fashion design, filming industry, development of educational content and technologies, video games, etc.).",
                    "Investments increasing the use of high-quality service inputs in industry (3D printing, robotics, big data analytics, blockchain, cloud computing, cybersecurity, Internet of Things, virtual/augmented reality technologies, etc.)."
                ]
            },
            {
                "id": "slide5",
                "frontImage": "/images/0-new-centers2_1.avif",
                "frontAlt": "High-quality Job Generating FDI Image",
                "frontNumber": "05",
                "frontTitle": "High-quality Job Generating FDI",
                "backTitle": "High-quality Job Generating FDI",
                "backBoldText": "Drawing in high-value and knowledge-intensive investments can create high-quality jobs and significantly increase a country’s GDP per capita.",
                "backImage": "/images/0-new-centers2_1.avif",
                "backRegularText": "Investments that create quality and high-paid jobs are considered as ‘Quality FDI’ projects for Türkiye. In the last 10 years, Türkiye has attracted 507 FDI projects under this profile.",
                "items": [
                    "Investments for technical training and support centers, regional headquarters, shared services centers.",
                    "R&D, design, and innovation center investments regardless of its sector.",
                    "Production investments in high-tech sectors creating jobs in STEM fields.",
                    "Investments in creative industries (architectural design, fashion design, filming industry, development of educational content and technologies, video games, etc.).",
                    "Investments in the financial services, ICT, life sciences, and professional services sectors.",
                    "Investments increasing the use of high-quality service inputs in the industry (3D printing, robotics, big data analytics, blockchain, cloud computing, cybersecurity, Internet of Things, virtual/augmented reality technologies, etc.).",
                    "Investments in Edtech, HealthTech, FinTech, smart home applications, and wearable technologies."
                ]
            },
            {
                "id": "slide6",
                "frontImage": "/images/computer_1.avif",
                "frontAlt": "High-end Service FDI Image",
                "frontNumber": "06",
                "frontTitle": "High-end Service FDI",
                "backTitle": "High-end Service FDI",
                "backBoldText": "The weight of the services sector in global FDI is steadily increasing. Producing high value-added services is crucial for enhancing the generated value in the economy.",
                "backImage": "/images/computer_1.avif",
                "backRegularText": "Investments in the high-quality service sectors are considered as ‘Quality FDI’ projects for Türkiye. In the last 10 years, Türkiye has attracted 406 FDI projects under this profile.",
                "items": [
                    "R&D, design, and innovation center investments regardless of its sector.",
                    "Investments in high value-added business services sector (creative advertising, high quality consultancy, engineering services, technical training, legal, financial, and HR consultancy, etc.).",
                    "Investments increasing the use of high-quality service inputs in the industry (3D printing, robotics, big data analytics, blockchain, cloud computing, cybersecurity, Internet of Things, virtual/augmented reality technologies, etc.).",
                    "Investments in the banking, finance, and insurance sectors.",
                    "Investments in software and gaming sectors.",
                    "Regional headquarters.",
                    "Investments in maintenance & servicing and technical support centers.",
                    "Shared services centers."
                ]
            },
            {
                "id": "slide7",
                "frontImage": "/images/qualified_investment_1.avif",
                "frontAlt": "High-quality Financial FDI Image",
                "frontNumber": "07",
                "frontTitle": "High-quality Financial FDI",
                "backTitle": "High-quality Financial FDI",
                "backBoldText": "High-quality financial investments provide funds to innovative start-ups and enable them to grow and internationalize faster.",
                "backImage": "/images/qualified_investment_1.avif",
                "backRegularText": "Financial investments in sustainable and knowledge intensive areas are considered as ‘Quality FDI’ projects.",
                "items": [
                    "Fund investments strengthening Türkiye’s start-up ecosystem.",
                    "Fund investments supporting seed funding, crowdfunding ecosystems, and business angel networks in the country.",
                    "Sustainable fund investments made by venture capital funds, private equity funds, development finance institutions, family offices, sovereign wealth funds, pension funds, and asset management companies.",
                    "Investments supporting the participation finance ecosystem.",
                    "Impact investing."
                ]
            },
            {
                "id": "slide8",
                "frontImage": "/images/Local-Economic-Cultural-Development-1_1.avif",
                "frontAlt": "Regional Development Oriented FDI Image",
                "frontNumber": "08",
                "frontTitle": "Regional Development Oriented FDI",
                "backTitle": "Regional Development Oriented FDI",
                "backBoldText": "FDI makes significant contributions to increasing the competitiveness of the regions, strengthening the global integration of those regions and reducing the economic disparities within a country.",
                "backImage": "/images/Local-Economic-Cultural-Development-1_1.avif",
                "backRegularText": "Investments that activate the endogenous potential of regions within the country, provide local supply opportunities, create high employment, and thus reduce migration from the regions are considered as “Quality FDI” projects for Türkiye.",
                "backRegularSubText": "Investments made within the provinces at 3rd, 4th, 5th, and 6th level of development according to the Socio-Economic Development Indexation (SEDI) study;",
                "items": [
                    "Investments in industrial sectors with 50+ employment.",
                    "Investments in employment-intensive service sectors (call centers, logistics and distribution centers, etc.).",
                    "Investments in sustainable agriculture and livestock activities.",
                    "Investments to increase the tourism potential of the regions and develop the tourism infrastructure.",
                    "Investments in the above-mentioned seven quality FDI profiles."
                ]
            }
        ]
    },
    "qualityFdiSection": {
        "mockupImage": "/images/mockup_reduced_1.webp",
        "mockupAlt": "FDI Mockup Image",
        "pdfLink": "https://www.invest.gov.tr/en/library/publications/lists/investpublications/turkiye-foreign-direct-investment-strategy-2024-2028.pdf",
        "pdfLabel": "Download PDF",
        "tagline": "FUNDAMENTAL PRINCIPLES",
        "heading": "Türkiye's FDI&nbsp;Strategy",
        "features": [
            {
                "id": "1",
                "className": "content-features-column",
                "icon": "",
                "title": "Aligned with Global Trends",
                "description": "The trends likely to influence FDI flows have been thoroughly analyzed, considering the global economic transformation and Türkiye’s needs."
            },
            {
                "id": "w-node-aa06b421-a47c-8074-6cb5-f60b951b4972-951b493d",
                "className": "content-features-column",
                "icon": "",
                "title": "Sustainable Development Goals (SDGs) Oriented",
                "description": "Eight different types of quality FDI profiles that will contribute to Türkiye’s sustainable development have been precisely defined."
            },
            {
                "id": "w-node-aa06b421-a47c-8074-6cb5-f60b951b494a-951b493d",
                "className": "content-feature-item",
                "icon": "",
                "title": "A Data-Driven Approach",
                "description": "At each stage, comprehensive analyses have been conducted relying on numerous national and international databases."
            },
            {
                "id": "w-node-aa06b421-a47c-8074-6cb5-f60b951b4969-951b493d",
                "className": "content-feature-item",
                "icon": "",
                "title": "A National Roadmap for FDI Attraction",
                "description": "A national-level defined roadmap for attracting quality FDI projects has been crafted, and the institutional framework and governance structure have been detailed."
            },
            {
                "id": "w-node-aa06b421-a47c-8074-6cb5-f60b951b495f-951b493d",
                "className": "content-feature-item",
                "icon": "",
                "title": "A Participatory Process",
                "description": "The strategy has been designed with the participation of all key stakeholders including relevant public institutions, professional business organizations, existing international investors, academia, and international institutions."
            }
        ]
    },
    "insightsSection": {
        "tagline": "FDI STRATEGY",
        "heading": "Get More Insights",
        "tabs": [
            {
                "id": "tab1",
                "tabId": "w-node-dbdb231f-3721-ba01-b35b-fe8525f08ce7-9d204e45",
                "icon": "",
                "title": "Key Trends & Insights",
                "description": "Overview of the Key Trends from the Report",
                "cards": [
                    {
                        "id": "w-node-_8de50c2f-4414-9316-7bae-0b3c7a75c0a4-9d204e45",
                        "tagline": "KEY TRENDS & INSIGHTS",
                        "heading": "Global & Regional FDI Flows",
                        "description": "Learn more about the Global & Regional FDI Flows.",
                        "link": "/insights#fdi-inflows",
                        "cardId": "w-node-_8de50c2f-4414-9316-7bae-0b3c7a75c0a4-9d204e45"
                    },
                    {
                        "id": "w-node-_3cb4207e-aef5-b5ab-6667-e33bc628ab5d-9d204e45",
                        "tagline": "FDI STRATEGY",
                        "className": "bento-card bg _1 w-inline-block",
                        "heading": "Announced FDI Projects in the CEEMENA Region",
                        "description": "Türkiye has become the region’s most attractive investment destination in the food and agriculture and industrial sectors.",
                        "link": "/insights#fdi-projects",
                        "cardId": "w-node-_3cb4207e-aef5-b5ab-6667-e33bc628ab5d-9d204e45"
                    },
                    {
                        "id": "w-node-dd0b2880-ca5c-30d7-97f9-e9d606a5c1fb-9d204e45",
                        "tagline": "FDI STRATEGY",
                        "heading": "8 Key Trends in Global FDI",
                        "link": "/insights#key-trends",
                        "cardId": "w-node-dd0b2880-ca5c-30d7-97f9-e9d606a5c1fb-9d204e45",
                        "carouselClass": "content-carousel",
                        "carouselGroups": [
                            {
                                "groupClass": "content-carousel-group",
                                "images": [
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-04.webp",
                                        "alt": "Global FDI Trend 04",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-01.webp",
                                        "alt": "Global FDI Trend 01",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-07_1.webp",
                                        "alt": "Global FDI Trend 07",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-03_1.webp",
                                        "alt": "Global FDI Trend 03",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-05_1.webp",
                                        "alt": "Global FDI Trend 05",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-02_1.webp",
                                        "alt": "Global FDI Trend 02",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-06_1.webp",
                                        "alt": "Global FDI Trend 06",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-08_1.webp",
                                        "alt": "Global FDI Trend 08",
                                        "class": "icon-gigantic"
                                    }
                                ]
                            },
                            {
                                "groupClass": "content-carousel-group",
                                "images": [
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-04.webp",
                                        "alt": "Global FDI Trend 04",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-01.webp",
                                        "alt": "Global FDI Trend 01",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-07_1.webp",
                                        "alt": "Global FDI Trend 07",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-03_1.webp",
                                        "alt": "Global FDI Trend 03",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-05_1.webp",
                                        "alt": "Global FDI Trend 05",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-02_1.webp",
                                        "alt": "Global FDI Trend 02",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-06_1.webp",
                                        "alt": "Global FDI Trend 06",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-08_1.webp",
                                        "alt": "Global FDI Trend 08",
                                        "class": "icon-gigantic"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "w-node-_8de50c2f-4414-9316-7bae-0b3c7a75c0b1-9d204e45",
                        "heading": "Read More About Key Trends & Insights.",
                        "headingClassName": "h4-heading h4-read-more light",
                        "className": "bento-card color-bg w-inline-block",
                        "description": "",
                        "descriptionClassName": "description white",
                        "iconClassName": "fa-solid-span white",
                        "link": "/insights",
                        "cardId": "w-node-_8de50c2f-4414-9316-7bae-0b3c7a75c0b1-9d204e45"
                    }
                ]
            },
            {
                "id": "tab2",
                "tabId": "w-node-dbdb231f-3721-ba01-b35b-fe8525f08cf5-9d204e45",
                "icon": "",
                "title": "Türkiye's FDI Performance",
                "description": "Discover Türkiye's FDI Performance",
                "cards": [
                    {
                        "id": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ff90-9d204e45",
                        "tagline": "TÜRKİYE'S FDI PERFORMANCE",
                        "heading": "Legal Regulations & Key Factors",
                        "description": "Discover continuous reform process and key factors lying behind Türkiye's outstanding FDI performance.",
                        "link": "/insights#fdi-performance",
                        "cardId": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ff90-9d204e45"
                    },
                    {
                        "id": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ff9d-9d204e45",
                        "tagline": "TÜRKİYE'S FDI PERFORMANCE",
                        "heading": "Türkiye's Startup Ecosystem",
                        "className": "bento-card bg _2 w-inline-block",
                        "description": "Turkish startup ecosystem has all key stakeholders in place and offers a vivid environment to international investors.",
                        "link": "/insights#startup-ecosystem",
                        "cardId": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ff9d-9d204e45"
                    },
                    {
                        "id": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ffaa-9d204e45",
                        "tagline": "TÜRKİYE'S FDI PERFORMANCE",
                        "heading": "The Contribution of FDI to the Turkish Economy",
                        "className": "bento-card bg icon-show w-inline-block",
                        "link": "/insights#contribution",
                        "cardId": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ffaa-9d204e45"
                    },
                    {
                        "id": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ffdb-9d204e45",
                        "className": "bento-card color-bg w-inline-block",
                        "heading": "Read More About Key Trends & Insights.",
                        "headingClassName": "h4-heading  h4-read-more light",
                        "description": "",
                        "descriptionClassName": "description white",
                        "iconClassName": "fa-solid-span white",
                        "link": "/insights",
                        "cardId": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ffdb-9d204e45"
                    }
                ]
            },
            {
                "id": "tab3",
                "tabId": "w-node-dbdb231f-3721-ba01-b35b-fe8525f08d03-9d204e45",
                "icon": "",
                "title": "Key Findings & Goals",
                "description": "10 Key Findings Guiding the Strategy",
                "cards": [
                    {
                        "id": "w-node-_2bda0364-020c-dc46-9fb6-134667d5306a-9d204e45",
                        "tagline": "KEY FINDINGS",
                        "heading": "10 Key Findings Guiding the Strategy",
                        "className": "bento-card bg key-findings w-inline-block",
                        "link": "/insights#key-findings",
                        "cardId": "w-node-_2bda0364-020c-dc46-9fb6-134667d5306a-9d204e45"
                    },
                    {
                        "id": "w-node-_2bda0364-020c-dc46-9fb6-134667d5309b-9d204e45",
                        "heading": "Read More About Key Trends & Insights.",
                        "headingClassName": "h4-heading h4-read-more light",
                        "description": "",
                        "descriptionClassName": "description white",
                        "className": "bento-card color-bg w-inline-block",
                        "iconClassName": "fa-solid-span white",
                        "link": "/insights",
                        "cardId": "w-node-_2bda0364-020c-dc46-9fb6-134667d5309b-9d204e45"
                    },
                    {
                        "id": "w-node-_6ab104b9-9e8f-71a6-c9ef-3afbc8b2f88e-9d204e45",
                        "tagline": "KEY FINDINGS",
                        "heading": "The Primary Goal and Policy Areas of the Strategy",
                        "className": "bento-card bg primary-goals w-inline-block",
                        "link": "/insights#goals",
                        "cardId": "w-node-_6ab104b9-9e8f-71a6-c9ef-3afbc8b2f88e-9d204e45"
                    }
                ]
            }
        ]
    },
    "insightsHero": {
        "tagline": "FDI STRATEGY",
        "heading": "Insights & Key Findings",
        "paragraph": "A Comprehensive Overview of the Insights and Key Findings that Shaped Türkiye’s FDI Strategy",
        "className": "cover-image insights",
        "id": "w-node-_315b066c-9375-5d43-64fe-99c0825fb648-bda32aac",
        "downloadButton": {
            "text": "Download PDF",
            "link": "https://www.invest.gov.tr/en/library/publications/lists/investpublications/turkiye-foreign-direct-investment-strategy-2024-2028.pdf"
        },
        "image": {
            "src": "/images/mockup_reduced_1.webp",
            "alt": "Insights Mockup Image",
            "srcset": "/images/mockup_reduced_1mockup_reduced.webp 500w, /images/mockup_reduced_1mockup_reduced.webp 800w, /images/mockup_reduced_1mockup_reduced.webp 1080w, /images/mockup_reduced_1.webp 1600w"
        }
    },
    "sectionIntro": {
        "icon": "",
        "tagline": "INSIGHTS & FINDINGS",
        "heading1": "Global FDI Outlook and Key Trends"
    },
    "fdiInflows": {
        "tagline": "FDI STRATEGY",
        "heading": "Global FDI Inflows",
        "description": "Global FDI inflows, excluding peaks triggered by large-scale mergers and acquisitions (M&A) in 2015 and 2016, have plateaued out since the 2008 Global Financial Crisis.",
        "downloadLink": "https://www.invest.gov.tr/en/Documents/national-fdi-strategy-action-plan-2026.pdf",
        "downloadLabel": "Download PDF",
        "cards": [
            {
                "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f317-bda32aac",
                "title": "Shifting Dynamics in Global FDI: Post-Crisis Plateau, Pandemic Impact, and Rise of Developing Countries",
                "description": "Global FDI inflows have remained stagnant since the 2008 financial crisis, with notable fluctuations in recent years. The COVID-19 pandemic caused a sharp decline in 2020, followed by a surge in 2021 driven by M&A transactions. However, this rebound was short-lived, as rising inflation and geopolitical tensions have recently contributed to a renewed downward trend. The pandemic also reshaped global supply chains, spurring increased investments in green and digital sectors. On the other hand, since 2018, developing countries have consistently outpaced developed nations in attracting FDI, a trend that has continued since 2020."
            },
            {
                "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f31e-bda32aac",
                "title": "Share of Developed and Developing Countries in Global FDI Inflows (%)",
                "description": "",
                "imageUrl": "/images/chart-3.webp"
            },
            {
                "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f325-bda32aac",
                "bullets": [
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f329-bda32aac",
                        "icon": "",
                        "className": "reddish",
                        "title": "Post-2008 Plateau",
                        "description": "FDI stagnation excluding 2015-2016 peaks"
                    },
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f331-bda32aac",
                        "icon": "",
                        "className": "reddish",
                        "title": "Pandemic Decline",
                        "description": "2020 lowest FDI in 15 years"
                    },
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f339-bda32aac",
                        "icon": "",
                        "className": "reddish",
                        "title": "2021 Surge",
                        "description": "Driven by M&A transactions"
                    },
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f341-bda32aac",
                        "icon": "",
                        "className": "reddish",
                        "title": "Downward Trajectory",
                        "description": "Global FDI flows influenced by protectionist measures and geopolitical tensions"
                    }
                ]
            },
            {
                "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f349-bda32aac",
                "bullets": [
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f34d-bda32aac",
                        "icon": "",
                        "className": "green",
                        "title": "Supply Chain Reshaping",
                        "description": "Increase in new investments post-pandemic"
                    },
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f355-bda32aac",
                        "icon": "",
                        "className": "green",
                        "title": "Green and Digital Transformation",
                        "description": "Rising trend"
                    },
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f35d-bda32aac",
                        "icon": "",
                        "className": "green",
                        "title": "Developing Countries Surpass",
                        "description": "Higher FDI inflows than developed countries since 2020"
                    },
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f365-bda32aac",
                        "icon": "",
                        "className": "green",
                        "title": "Increasing Trends",
                        "description": "Post-pandemic increase in greenfield investments"
                    }
                ]
            },
            {
                "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f31e-bda32aac",
                "title": "Global FDI Inflows, M&A and Greenfield Investments",
                "titleStrong": "(Trillion USD)",
                "description": "",
                "imageUrl": "/images/chart-2.webp"
            }
        ]
    },
    "infographicsSection": {
        "tagline": "FDI STRATEGY",
        "heading": "FDI Inflows in the Region",
        "description": "The CEEMENA region, encompassing Central and Eastern Europe, the Middle East, and North Africa, has witnessed a notable recovery in FDI inflows since 2015, following a prolonged decline after the Global Financial Crisis. Total FDI to the region more than doubled from $72 billion in 2015 to $178,3 billion in 2023, despite global FDI contraction. Within this dynamic context, Türkiye stands out as a key destination for international investors, leveraging its strategic location at the crossroads of the region and attracting significant interest across diverse sectors. Investors frequently shortlist Türkiye when exploring new opportunities in region.",
        "bulletPoints": [
            {
                "icon": "M12 4.5C16.1423 4.5 19.5 7.85775 19.5 12C19.5 16.1423 16.1423 19.5 12 19.5C7.85775 19.5 4.5 16.1423 4.5 12C4.5 7.85775 7.85775 4.5 12 4.5ZM12 6C10.4087 6 8.88258 6.63214 7.75736 7.75736C6.63214 8.88258 6 10.4087 6 12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18C13.5913 18 15.1174 17.3679 16.2426 16.2426C17.3679 15.1174 18 13.5913 18 12C18 10.4087 17.3679 8.88258 16.2426 7.75736C15.1174 6.63214 13.5913 6 12 6ZM12 8.25C12.7894 8.2503 13.5586 8.49973 14.198 8.96275C14.8374 9.42578 15.3144 10.0788 15.561 10.8287C15.8075 11.5787 15.8112 12.3873 15.5713 13.1394C15.3314 13.8915 14.8603 14.5488 14.2251 15.0175C13.5898 15.4862 12.8229 15.7425 12.0335 15.7498C11.2441 15.7572 10.4725 15.5152 9.82864 15.0584C9.18479 14.6016 8.70153 13.9533 8.4477 13.2057C8.19388 12.4582 8.18243 11.6497 8.415 10.8953C8.59044 11.2873 8.89521 11.6072 9.27829 11.8014C9.66138 11.9956 10.0995 12.0523 10.5195 11.9621C10.9394 11.8719 11.3156 11.6402 11.5851 11.3057C11.8546 10.9713 12.0011 10.5545 12 10.125C12.0001 9.76385 11.8959 9.41036 11.6999 9.10701C11.5039 8.80366 11.2245 8.56336 10.8953 8.415C11.2448 8.30775 11.6153 8.25 12 8.25Z",
                "title": "Strategic Location",
                "description": "Türkiye’s unique location"
            },
            {
                "icon": "M13.5 13.689V15.2565C12.8212 15.0165 12.0947 14.9429 11.3816 15.0418C10.6684 15.1408 9.9894 15.4094 9.40157 15.8252C8.81375 16.2409 8.33426 16.7916 8.00337 17.4311C7.67249 18.0705 7.49986 18.78 7.5 19.5L6 19.4993C5.99977 18.5834 6.20919 17.6797 6.61222 16.8573C7.01526 16.0349 7.6012 15.3157 8.32516 14.7548C9.04912 14.1939 9.89188 13.8061 10.7889 13.6212C11.6858 13.4364 12.6132 13.4593 13.5 13.6883V13.689ZM12 12.75C9.51375 12.75 7.5 10.7362 7.5 8.25C7.5 5.76375 9.51375 3.75 12 3.75C14.4862 3.75 16.5 5.76375 16.5 8.25C16.5 10.7362 14.4862 12.75 12 12.75ZM12 11.25C13.6575 11.25 15 9.9075 15 8.25C15 6.5925 13.6575 5.25 12 5.25C10.3425 5.25 9 6.5925 9 8.25C9 9.9075 10.3425 11.25 12 11.25ZM16.5 15.75V13.5H18V15.75H20.25V17.25H18V19.5H16.5V17.25H14.25V15.75H16.5Z",
                "title": "Top Destination",
                "description": "Frequently shortlisted country"
            },
            {
                "icon": "M11.25 4.53749V6.80249C8.706 7.16774 6.75 9.35624 6.75 12C6.75 14.8995 9.1005 17.25 12 17.25C13.179 17.25 14.268 16.8615 15.144 16.2045L16.7467 17.8072C15.4538 18.8647 13.8 19.5 12 19.5C7.85775 19.5 4.5 16.1422 4.5 12C4.5 8.11124 7.46025 4.91324 11.25 4.53749ZM19.4625 12.75C19.3125 14.2582 18.717 15.6352 17.8073 16.746L16.2045 15.144C16.7198 14.457 17.0693 13.6395 17.1968 12.75H19.4633H19.4625ZM12.7515 4.53749C16.2945 4.88924 19.1115 7.70699 19.464 11.25H17.1975C16.869 8.95124 15.0503 7.13249 12.7515 6.80324V4.53674V4.53749Z",
                "title": "CEEMENA's Increasing Investment Appeal",
                "description": "Regional resilience amid global FDI decline"
            },
            {
                "icon": "M16.3807 14.7443L16.5128 14.877L16.6462 14.7443C16.8029 14.5876 16.989 14.4632 17.1937 14.3784C17.3985 14.2936 17.6179 14.25 17.8395 14.25C18.0611 14.25 18.2805 14.2936 18.4853 14.3784C18.69 14.4632 18.8761 14.5876 19.0328 14.7443C19.1895 14.901 19.3138 15.087 19.3986 15.2917C19.4834 15.4965 19.527 15.7159 19.527 15.9375C19.527 16.1591 19.4834 16.3785 19.3986 16.5833C19.3138 16.788 19.1895 16.974 19.0328 17.1307L16.5128 19.65L13.9943 17.1307C13.6778 16.8143 13.5 16.3851 13.5 15.9375C13.5 15.4899 13.6778 15.0607 13.9943 14.7443C14.3107 14.4278 14.7399 14.25 15.1875 14.25C15.6351 14.25 16.0643 14.4278 16.3807 14.7443ZM12 13.5V15C10.8065 15 9.66193 15.4741 8.81802 16.318C7.97411 17.1619 7.5 18.3065 7.5 19.5H6C6.00002 17.9412 6.6067 16.4436 7.6916 15.3242C8.7765 14.2049 10.2544 13.5517 11.8125 13.503L12 13.5ZM12 3.75C14.4862 3.75 16.5 5.76375 16.5 8.25C16.5004 9.4144 16.0493 10.5336 15.2416 11.3723C14.4338 12.2109 13.3323 12.7037 12.1688 12.747L12 12.75C9.51375 12.75 7.5 10.7362 7.5 8.25C7.49958 7.0856 7.95068 5.96641 8.75843 5.12774C9.56618 4.28908 10.6677 3.79629 11.8312 3.753L12 3.75ZM12 5.25C10.3425 5.25 9 6.5925 9 8.25C9 9.9075 10.3425 11.25 12 11.25C13.6575 11.25 15 9.9075 15 8.25C15 6.5925 13.6575 5.25 12 5.25Z",
                "title": "FDI Surge",
                "description": "Doubling inflows from 2015 to 2022"
            }
        ],
        "downloadLink": "https://www.invest.gov.tr/en/Documents/national-fdi-strategy-action-plan-2026.pdf",
        "downloadButton": "Download PDF"
    },
    "fdiCardsSection": {
        "cards": [
            {
                "id": "w-node-a6ebe047-e62c-2f05-5b73-de940367235d-bda32aac",
                "title": "The Region's Share in Global FDI Inflows (%)",
                "description": "Following the Global Financial Crisis, the region experienced a decline in its portion of global FDI inflows, continuing until 2015. However, since then, FDI inflows to the region have gained momentum in the face of contraction in global FDI. With this acceleration, the total FDI to the region between 2015 and 2023 more than doubled, reaching 178.3 billion USD in 2023 which was 67.4 billion USD in 2015.",
                "imageUrl": "/images/The-Regions-Share-in-Global-FDI-Inflows.png",
                "imageAlt": "The Region's Share in Global FDI Inflows"
            },
            {
                "id": "w-node-a6ebe047-e62c-2f05-5b73-de9403672365-bda32aac",
                "className": "dark",
                "title": "Türkiye stands as one of the most significant FDI destinations in the CEEMENA region.",
                "description": "Looking at the country-level breakdown, Türkiye has drawn in 261 billion USD of FDI over the last two decades (2004-2023), securing the second position with 9.8% market share in the CEEMENA region.",
                "iconUrl": "/images/Star-Graph.svg",
                "imageAlt": "Star Graph"
            }
        ]
    },
    "fdiProjectsSection": {
        "tagline": "FDI STRATEGY",
        "heading": "Türkiye: Leading Investment Destination in Food, Agriculture, and Industrial Sectors in CEEMENA",
        "description": "Türkiye has become the region’s most attractive investment destination in the food and agriculture and industrial sectors.",
        "downloadLink": "https://www.invest.gov.tr/en/Documents/national-fdi-strategy-action-plan-2026.pdf",
        "downloadButton": "Download PDF",
        "tabs": [
            {
                "id": "tab-1",
                "title": "Food & Agriculture",
                "description": "Türkiye has increased its share in the food and agriculture sector by more than three times in the last 10 years, attracting one in every five FDI projects in the CEEMENA region.",
                "icon": "",
                "iconClass": "yellow",
                "imageUrl": "/images/FoodAgriculture-Infographics.webp",
                "imageAlt": "Food & Agriculture Infographics"
            },
            {
                "id": "tab-2",
                "title": "Industry",
                "description": "The country has almost doubled its share in the industrial sector over the last 10 years. Manufacturing investments in sectors integrated with global value chains (GVCs) such as automotive, machinery, and chemicals have played a major role in this increase.",
                "icon": "",
                "iconClass": "turqoise",
                "imageUrl": "/images/Industry-Infographics.webp",
                "imageAlt": "Industry Infographics"
            },
            {
                "id": "tab-3",
                "title": "Services",
                "description": "Although Türkiye has maintained the number of projects it has attracted to the service sector over the past decade, its regional share has slightly decreased.",
                "icon": "",
                "iconClass": "brown",
                "imageUrl": "/images/Service-Infographics.webp",
                "imageAlt": "Services Infographics"
            }
        ],
        "sourceInfo": "fDi Markets, 2023 & Investment Office’s Analyses"
    },
    "keyOutcomes": {
        "slides": [
            {
                "id": "slide-1",
                "keyInfoId": "w-node-_98fdce91-a221-1bc4-6d3d-37bb983c9b54-bda32aac",
                "contentWrapperId": "w-node-_98fdce91-a221-1bc4-6d3d-37bb983c9b63-bda32aac",
                "title": "INCREASE IN REGIONAL SHARE IN MANUFACTURING PROJECTS",
                "fact": "<span class='number-fact'>4.5</span> TIMES",
                "footer": "<strong>2014-2023:</strong><br>Compared to Previous",
                "description": {
                    "heading": "FDI PROJECTS ANNOUNCED IN THE CEEMENA REGION BY ACTIVITY",
                    "content": "The distribution of announced FDI projects by activity type illustrates that manufacturing, research and development (R&D), and Shared Services Center (SSC) projects in the CEEMENA region have seen a substantial growth in the post-pandemic period. In particular, SSC projects have established a new record by surging approximately 2.5 times in the last 3 years",
                    "highlight": "Türkiye is by far the leading investment destination in CEEMENA for manufacturing projects.",
                    "details": "Between 2014 and 2023, compared to the previous decade, Türkiye has increased its share in manufacturing projects by nearly 4.5 times, becoming by far the leading country in CEEMENA with 22% share. During the same period, it has increased its regional share in R&D projects"
                }
            },
            {
                "id": "slide-2",
                "keyInfoId": "w-node-_98fdce91-a221-1bc4-6d3d-37bb983c9b72-bda32aac",
                "contentWrapperId": "w-node-_98fdce91-a221-1bc4-6d3d-37bb983c9b87-bda32aac",
                "title": "IN M&A INVESTMENTS",
                "fact": "<span class='number-fact'>2</span>ND MOST<br>ATTRACTIVE<br>COUNTRY<br>IN THE REGION",
                "footer": "<strong>2004-2023:</strong><br>By the Number of Projects",
                "description": {
                    "heading": "M&A Investments in CEEMENA",
                    "content": "The region, which covers Central and Eastern Europe, the Middle East, and North Africa, is among the world’s leading destinations not only for greenfield investments but also for M&A projects. After the pandemic, approximately 7% of global M&A transactions (based on both the number of projects and the investment amount) have been announced in this region",
                    "highlight": "Türkiye is the second most attractive destination for M&A investments in CEEMENA. ",
                    "details": "Based on the number of projects, Türkiye has attracted 8.3% of M&A projects in CEEMENA over the past 20 years. "
                }
            },
            {
                "id": "slide-3",
                "keyInfoId": "w-node-_330a69f9-c3c3-7b8d-a818-b9162e580f7d-bda32aac",
                "contentWrapperId": "w-node-_330a69f9-c3c3-7b8d-a818-b9162e580f8c-bda32aac",
                "title": "IN GREENFIELD INVESTMENTS",
                "fact": "<span class='number-fact'>3</span>RD MOST<br>ATTRACTIVE<br>COUNTRY<br>IN THE REGION",
                "footer": "<strong>2014-2023:</strong><br>By the Number of Projects",
                "description": {
                    "heading": "FDI Projects Announced in the CEEMENA Region by Activity",
                    "content": "The number of announced greenfield projects in CEEMENA experienced a significant downturn in 2009 due to the Global Financial Crisis and demonstrated a stable trend in the following years until the outbreak of the pandemic. However, it recovered rapidly after the pandemic and reached its highest level of the last two decades in 2023. The number of greenfield projects announced in 2023 increased by 75% compared to 2020.",
                    "highlight": "Türkiye is among the top countries in CEEMENA in terms of attracting greenfield FDI.",
                    "details": "In the 2014-2023 period, compared to the previous decade, Türkiye registered a notable increase in its share of greenfield investments and became among the top three countries in CEEMENA. "
                }
            },
            {
                "id": "slide-4",
                "keyInfoId": "w-node-a1c8d248-9cd8-03a7-57ee-8971955b7daa-bda32aac",
                "contentWrapperId": "w-node-a1c8d248-9cd8-03a7-57ee-8971955b7dc1-bda32aac",
                "title": "INCREASE IN REGIONAL SHARE IN EXPANSION PROJECTS",
                "fact": "<span class='number-fact'>5</span> TIMES",
                "footer": "<strong>2014-2023:</strong><br>Compared to Previous Decade",
                "description": {
                    "heading": "EXPANSION-TYPE FDI PROJECTS ANNOUNCED IN CEEMENA",
                    "content": "The number of expansion investments announced in CEEMENA has generally been on an upward trend in the last decade. Compared to the pre-pandemic period, the number of expansion investments announced in 2022 increased by 61% and by 34% in 2023.",
                    "highlight": "Türkiye is by far the leading country in CEEMENA in expansion investments.",
                    "details": "In the 2014-2023 period, compared to the previous decade, Türkiye increased its share in expansion type investments approximately 5 times (from 3.9% to 19.7%), becoming by far the leading country in CEEMENA. This indicates that international companies which have investments in the country, opt for Türkiye again to expand their operations in CEEMENA and to strengthen their regional value chains"
                }
            }
        ]
    },
    "fdiTrends": {
        "tagline": "FDI STRATEGY",
        "heading": "8 Key Trends in Global FDI",
        "description": "The global FDI landscape is undergoing significant transformation, with investors’ decisions increasingly influenced by eight major trends. A thorough understanding of these trends is crucial for all stakeholders to effectively design and implement Türkiye’s national FDI strategy.",
        "downloadText": "Download PDF",
        "pdfLink": "https://www.invest.gov.tr/en/Documents/national-fdi-strategy-action-plan-2026.pdf",
        "flipCards": [
            {
                "id": "trend-01",
                "frontImage": "/images/GlobalFDI-Trend-01.webp",
                "frontAlt": "Global Value Chains (GVCs) Are Being Reshaped",
                "frontNumber": "01",
                "frontTitle": "Global Value Chains (GVCs) Are Being Reshaped",
                "frontDescription": "",
                "backTitle": "Global Value Chains (GVCs) Are Being Reshaped",
                "backBoldText": "Geopolitical tensions, climate change and natural disasters, pandemics, and the increasing importance of sustainability and digitalization concepts are leading to a reconfiguration of global value chains.",
                "backImage": "/images/GlobalFDI-Trend-01.webp",
                "backRegularText": "",
                "frontTagline": "FDI TRENDS"
            },
            {
                "id": "trend-02",
                "frontImage": "/images/GlobalFDI-Trend-02_1.webp",
                "frontAlt": "Deglobalization and Protectionism Trends Are Strengthening",
                "frontNumber": "02",
                "frontTitle": "Deglobalization and Protectionism Trends Are Strengthening",
                "frontDescription": "",
                "backTitle": "Deglobalization and Protectionism Trends Are Strengthening",
                "backBoldText": "Recent tensions among the economic blocs have led countries to adopt more protectionist and inward-looking policies in investment and trade, driven by national security concerns.",
                "backImage": "/images/GlobalFDI-Trend-02_1.webp",
                "backRegularText": "",
                "frontTagline": "FDI TRENDS"
            },
            {
                "id": "trend-03",
                "frontImage": "/images/GlobalFDI-Trend-03_1.webp",
                "frontAlt": "Global Economic Uncertainties Are Surging",
                "frontNumber": "03",
                "frontTitle": "Global Economic Uncertainties Are Surging",
                "frontDescription": "",
                "backTitle": "Global Economic Uncertainties Are Surging",
                "backBoldText": "Geopolitical tensions, climate change and natural disasters, pandemics, and the increasing importance of sustainability and digitalization concepts are leading to a reconfiguration of global value chains.",
                "backImage": "/images/GlobalFDI-Trend-03_1.webp",
                "backRegularText": "",
                "frontTagline": "FDI TRENDS"
            },
            {
                "id": "trend-04",
                "frontImage": "/images/GlobalFDI-Trend-04.webp",
                "frontAlt": "Economic and Political Fragmentation on a Global Scale Is Deepening",
                "frontNumber": "04",
                "frontTitle": "Economic and Political Fragmentation on a Global Scale Is Deepening",
                "frontDescription": "",
                "backTitle": "Economic and Political Fragmentation on a Global Scale Is Deepening",
                "backBoldText": "Recent global economic and political fragmentations have led to protectionist measures, significantly impacting the global economy. Reports from the IMF, World Bank, UNCTAD, and OECD highlight how these trends are affecting FDI and financial investment flows worldwide.",
                "backImage": "/images/GlobalFDI-Trend-04.webp",
                "backRegularText": "",
                "frontTagline": "FDI TRENDS"
            },
            {
                "id": "trend-05",
                "frontImage": "/images/GlobalFDI-Trend-05_1.webp",
                "frontAlt": "Climate Change and Environmental Sustainability Play a Transformative Role in FDI",
                "frontNumber": "05",
                "frontTitle": "Climate Change and Environmental Sustainability Play a Transformative Role in FDI",
                "frontDescription": "",
                "backTitle": "Climate Change and Environmental Sustainability Play a Transformative Role in FDI",
                "backBoldText": "In recent years, climate change mitigation and adaptation strategies have become one of the most critical agenda items for the private sector and policymakers. Driven by global and regional climate policies such as the Paris Climate Agreement and the EU Green Deal, the importance of environmental sustainability is steadily increasing, and deeply affecting FDI trends.",
                "backImage": "/images/GlobalFDI-Trend-05_1.webp",
                "backRegularText": "",
                "frontTagline": "FDI TRENDS"
            },
            {
                "id": "trend-06",
                "frontImage": "/images/GlobalFDI-Trend-06_1.webp",
                "frontAlt": "Digital Transformation Is Accelerating",
                "frontNumber": "06",
                "frontTitle": "Digital Transformation Is Accelerating",
                "frontDescription": "",
                "backTitle": "Digital Transformation Is Accelerating",
                "backBoldText": "The acceleration of the digitalization process on a global level is transforming traditional sectors and facilitating the growth of new ones.",
                "backImage": "/images/GlobalFDI-Trend-06_1.webp",
                "backRegularText": "",
                "frontTagline": "FDI TRENDS"
            },
            {
                "id": "trend-07",
                "frontImage": "/images/GlobalFDI-Trend-07_1.webp",
                "frontAlt": "Regional and National Industrial Policies Are Gaining Greater Importance",
                "frontNumber": "07",
                "frontTitle": "Regional and National Industrial Policies Are Gaining Greater Importance",
                "frontDescription": "",
                "backTitle": "Regional and National Industrial Policies Are Gaining Greater Importance",
                "backBoldText": "Industrial policies have been gaining momentum in many countries that started with the 2008 Global Financial Crisis and accelerated with the increasing geopolitical tensions worldwide. Many major economies are designing comprehensive incentive packages for strategic sectors under these new industrial policies.",
                "backImage": "/images/GlobalFDI-Trend-07_1.webp",
                "backRegularText": "",
                "frontTagline": "FDI TRENDS"
            },
            {
                "id": "trend-08",
                "frontImage": "/images/GlobalFDI-Trend-08_1.webp",
                "frontAlt": "New Technologies and High-Quality Service Inputs Are Transforming the Manufacturing Industry",
                "frontNumber": "08",
                "frontTitle": "New Technologies and High-Quality Service Inputs Are Transforming the Manufacturing Industry",
                "frontDescription": "",
                "backTitle": "New Technologies and High-Quality Service Inputs Are Transforming the Manufacturing Industry",
                "backBoldText": "The widespread adoption of technologies such as AI-enhanced automation systems, robotics, and 3D printing is rapidly revolutionizing the manufacturing industry. This shift in production methodologies has diminished the significance of labor costs in the competition to attract investments, especially in labor-intensive sectors.",
                "backImage": "/images/GlobalFDI-Trend-08_1.webp",
                "backRegularText": "",
                "frontTagline": "FDI TRENDS"
            }
        ]
    },
    "fdiPerformance": {
        "id": "fdi-performance",
        "header": {
            "icon": "<span class='fontawesome'></span>",
            "tagline": "INSIGHTS & FINDINGS",
            "heading": "Türkiye's FDI Performance",
            "description":"Over the past 20 years, Türkiye has emerged as an attractive FDI destination thanks to various factors, including continuous and strong reform agenda, economic and political stability, a young and dynamic population, and a strategic location it offers."
        },
        "cards": [
            {
                "id": "w-node-a3d0e202-8c68-27c1-4f72-91fb61149c02-bda32aac",
                "title": "New Legal Regulations and Continuous Reform Process",
                "content": "<blockquote>Foreign Direct Investment (FDI) Law</blockquote><blockquote>Comprehensive Incentive Schemes</blockquote><blockquote>Strong Agenda for Sustainability and Green Transformation</blockquote><blockquote>Establishment of the Coordination Council for the Improvement of the Investment Environment (YOIKK)</blockquote><blockquote>Establishment of the Investment Office of Türkiye Reforms in Fundamental Laws</blockquote><blockquote>Judicial Reforms to Improve the Investment Environment</blockquote><blockquote>Strong Engagement with Ease of Doing Business / Business Ready (B-READY) Indices</blockquote>"
            },
            {
                "id": "w-node-_9597edd6-e4a9-c1c1-94ed-00f8328a69e7-bda32aac",
                "title": "Key Factors Lying Behind Türkiye’s Outstanding FDI Performance",
                "content": "<ul><li>Continuous Economic and Political Stability</li><li>Resilience Against Global Shocks</li><li>Young and Dynamic Population</li><li>Highly Skilled Talent Pool</li><li>Robust Infrastructure</li><li>Digital Transformation</li><li>Vibrant R&D Ecosystem</li><li>Geostrategic Location</li><li>Customs Union with European Union (EU)</li><li>A Wide Range of Free Trade Agreements</li><li>Strong Integration into Global Value Chains (GVCs)</li><li>Robust Economic Growth</li><li>Production and Export Hub of the Region</li></ul>"
            }
        ],
        "statisticsCard": {
            "id": "w-node-_9909d3a2-4e8e-300a-e2aa-d73a9ab7a136-bda32aac",
            "title": "Türkiye's FDI Performance Statistics",
            "statistics": "<div class=\"content-statistics\"><div id=\"w-node-d16f4fcd-8b7b-f70d-af48-881525d25db5-bda32aac\" class=\"stats-grid\"><div class=\"h6-heading yellow\">Total&nbsp;FDI&nbsp;Inflows</div><div class=\"counter-wrap grayscale\"><div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"250\" fb-count-time=\"3000\" class=\"stat-heading\">15 Billion</div><div class=\"counter-text\">1973-2002</div></div><div class=\"counter-wrap\"><div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"250\" fb-count-time=\"3000\" class=\"stat-heading\">262 Billion</div><div class=\"counter-text\">2003-2023</div></div></div><div id=\"w-node-_82370bea-b0d8-eeb3-94c3-608f24aff697-bda32aac\" class=\"stats-grid\"><div class=\"h6-heading yellow\">Türkiye's Share in the Global FDI</div><div class=\"counter-wrap grayscale\"><div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"250\" fb-count-time=\"3000\" class=\"stat-heading\">0.2%</div><div class=\"counter-text\">1990-2002</div></div><div class=\"counter-wrap\"><div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"250\" fb-count-time=\"3000\" class=\"stat-heading\">0.9%</div><div class=\"counter-text\">2003-2023</div></div></div><div id=\"w-node-_920ce171-c107-880f-e275-3450d4bb76d8-bda32aac\" class=\"stats-grid\"><div class=\"h6-heading yellow\">Number of International Companies Operating in Türkiye</div><div class=\"counter-wrap grayscale\"><div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"250\" fb-count-time=\"3000\" class=\"stat-heading\">5,600</div><div class=\"counter-text\">2003</div></div><div class=\"counter-wrap\"><div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"250\" fb-count-time=\"3000\" class=\"stat-heading\">82,700</div><div class=\"counter-text\">2023</div></div></div><div id=\"w-node-_569286b7-76cb-3339-be86-7ec56e19a0f7-bda32aac\" class=\"stats-grid\"><div class=\"h6-heading yellow\">The Average Contribution of FDI to the Current&nbsp;Account Balance</div><div class=\"counter-wrap\"><div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"250\" fb-count-time=\"3000\" class=\"stat-heading\">40%</div><div class=\"counter-text\">2003-2023</div></div></div></div>"
        }
    },
    "startupEcosystem": {
        "tagline": "FDI STRATEGY",
        "heading": "Türkiye's Startup Ecosystem",
        "description": "Turkish startup ecosystem has all key stakeholders in place and offers a vivid environment to international investors.",
        "pdfLink": "https://www.invest.gov.tr/en/Documents/national-fdi-strategy-action-plan-2026.pdf",
        "buttonText": "Download PDF",
        "content":[
            "BUSINESS ANGEL NETWORKS",
            "VENTURE CAPITAL FUNDS",
            "PRIVATE EQUITY FUNDS",
            "TECHNOLOGY ZONES (TECHNOPARKS)",
            "INCUBATION CENTERS",
            "CROWDFUNDING",
            "SEED FUNDING",
            "ACCELERATORS",
            "GOVERNMENT SUPPORTS"
            ],
        "cards": [
            {
                "id": "w-node-b7006ced-f850-0673-fd0f-76ed306bf935-bda32aac",
                "heading": "Türkiye’s Startup Ecosystem Reaches New Heights in Early-Stage Investments",
                "description": "Between 2010 and 2020, Türkiye’s startup ecosystem attracted $74 million annually through 104 transactions on average. From 2021 to 2023, investments soared to $1.33 billion annually, with an average of 338 transactions.",
                "image": "/images/EN-FDI-Strategy-Report_2.png",
                "alt": "Startup Ecosystem Image"
            },
            {
                "id": "w-node-b7006ced-f850-0673-fd0f-76ed306bf93c-bda32aac",
                "heading": "The Number of Unicorns",
                "description": "2020-2023",
                "number": "5"
            },
            {
                "id": "w-node-c96aa4eb-355c-cee6-1fb6-1d84c63953dc-bda32aac",
                "heading": "The Number of Decacorns",
                "description": "2020-2023",
                "number": "2"
            }
        ]
    },
    "contributionSection": {
        "tagline": "FDI STRATEGY",
        "heading": "The Contribution of FDI to the Turkish Economy",
        "description": "FDI in Türkiye has helped finance the current account deficit and significantly contributed to the real economy through the activities of FDI companies.",
        "source": "<strong>Source:</strong> fDi Markets, 2023 & Investment Office’s Analyses",
        "tabs": [
            {
                "id": "employment",
                "iconClass": "yellow",
                "icon": "",
                "heading": "Employment",
                "content": "<div id=\"w-node-_02c9d632-bf27-911c-c94e-583f1e56e75e-bda32aac\" class=\"tab-bento-card\"><div class=\"bento-card-header gap20\"><div id=\"w-node-_78da1cfc-2e04-5e0f-4e01-b04d2a9e0574-bda32aac\" class=\"stats-grid\"><div class=\"h6-heading yellow\">Direct Employment</div><div class=\"counter-wrap grayscale\"><div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"250\" fb-count-time=\"3000\" class=\"stat-heading\">500,000 People</div><div class=\"counter-text\">2006</div></div><div class=\"counter-wrap\"><div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"250\" fb-count-time=\"3000\" class=\"stat-heading\">1,320,000 People</div><div class=\"counter-text\">2021</div></div></div><div id=\"w-node-_1eed080e-8ab4-37d1-ed55-d6ca9bf9dce7-bda32aac\" class=\"stats-grid gap20\"><div id=\"w-node-_33ca0750-6a3e-5dca-d9d3-4217311f3170-bda32aac\" class=\"h6-heading yellow\"><strong>FDI’s share within the total private sector employment</strong></div><img sizes=\"218.515625px\" srcset=\"/images/66b76e2728b4fd5accfce313_Employment Rate-p-500.png 500w, /images/66b76e2728b4fd5accfce313_Employment Rate-p-500.png 874w\" alt=\"\" src=\"/images/66b76e2728b4fd5accfce313_Employment Rate-p-500.png\" loading=\"lazy\" class=\"stat-graph _400px\"><p class=\"description\">While the registered employment of FDI companies was around 500,000 people in 2006, it reached 1,320,000 in 2021. <br>The share of these companies in total registered employment in Türkiye increased from 7.6% in 2006 to 8.8% in 2021.</p></div></div></div>"
            },
            {
                "id": "exports",
                "iconClass": "turqoise",
                "icon": "",
                "heading": "Exports",
                "content": "<div id=\"w-node-cc6eb5a8-0dfa-319c-c4b5-c78e87172e80-bda32aac\" class=\"tab-bento-card\"><div class=\"bento-card-header gap0\"><div class=\"stats-grid grid no-border\"><div id=\"w-node-e420dc75-08be-1f26-11e6-acdb03959688-bda32aac\" class=\"h6-heading yellow\"><strong>The Share of FDI Companies In Türkiye's Total Export</strong></div><img loading=\"lazy\" src=\"/images/FDI-Strategy-Report-Export.png\" alt=\"\" class=\"stat-graph\"><p class=\"description\">In the 2006-2021 period, approximately 31% of Türkiye’s total exports were made by FDI companies.</p></div><div class=\"stats-grid grid\"><div><h5 class=\"h6-heading turqoise right-aligned\"><span class=\"stat-heading\">2.5</span> TIMES<br>INCREASE</h5></div><p class=\"description\">While the exports of FDI companies were around 25 billion dollars in 2006, they increased to over 63 billion dollars in 2021.</p></div><div class=\"stats-grid grid\"><div><h5 class=\"h6-heading turqoise right-aligned\"><span class=\"stat-heading\">61%</span> MEDIUM&nbsp;HIGH-TECH &amp;&nbsp;HIGH-TECH&nbsp;EXPORTS</h5></div><p class=\"description\">In the 2006-2021 period, 61% of exports made by FDI companies consist of medium-high and high technology products. This rate is above the Turkish average.</p></div></div></div>"
            },
            {
                "id": "rnd",
                "iconClass": "brown",
                "icon": "",
                "heading": "Research & Development",
                "content": "<div id=\"w-node-_9d167489-4fae-9d43-6d1a-8502651eee1c-bda32aac\" class=\"tab-bento-card\"><div class=\"bento-card-header gap0\"><div class=\"stats-grid grid no-border\"><div id=\"w-node-_9d167489-4fae-9d43-6d1a-8502651eee1f-bda32aac\" class=\"h6-heading yellow\"><strong>The Share of FDI Companies In Private Sectors Total R&D Expenditures</strong></div><img sizes=\"100vw\" srcset=\"/images/RnD-Stats-p-500.png 500w, /images/RnD-Stats.png 559w\" alt=\"\" src=\"/images/RnD-Stats.png\" loading=\"lazy\" class=\"stat-graph\"><p class=\"description\">In the 2006-2021 period, 30.3% of the total private sector R&D expenditures in Türkiye were made by FDI companies.</p></div><div class=\"stats-grid grid\"><div><h5 class=\"h6-heading turqoise right-aligned\"><span class=\"stat-heading\">730</span> TOTAL&nbsp;PATENT APPLICATIONS</h5></div><p class=\"description\">FDI companies applied for an average of 730 patents annually.</p></div><div class=\"stats-grid grid\"><div><h5 class=\"h6-heading turqoise right-aligned\"><span class=\"stat-heading\">6 </span><strong>TIMES INCREASE</strong></h5></div><p class=\"description\">During the 2006-2021 period, the number of FDI companies conducting R&D in Türkiye increased 6-fold.</p></div></div></div>"
            },
            {
                "id": "local-sourcing",
                "iconClass": "turqoise",
                "icon": "",
                "heading": "Local Sourcing",
                "content": "<div id=\"w-node-_0a09421c-a7b6-5fd2-8a2c-c560abd8b29a-bda32aac\" class=\"tab-bento-card\"><div class=\"bento-card-header gap0\"><div class=\"stats-grid grid no-border\"><div id=\"w-node-_0a09421c-a7b6-5fd2-8a2c-c560abd8b29d-bda32aac\" class=\"h6-heading yellow\"><strong>Local Content Ratio</strong></div><img sizes=\"100vw\" srcset=\"/images/Local-Content-Ratio-p-500.png 500w, /images/Local-Content-Ratio.png 793w\" alt=\"\" src=\"/images/Local-Content-Ratio.png\" loading=\"lazy\" class=\"stat-graph\"><p class=\"description\">In the 2006-2021 period, FDI companies made 71.8% of their total supplies locally.</p></div></div></div>"
            }
        ]
    },
    "keyFindingsSection": {
        "sectionId": "key-findings",
        "tagline": "INSIGHTS & FINDINGS",
        "heading": "10 Key Findings Guiding the Strategy",
        "description": "As a result of detailed analyses of the global and regional outlook of FDI flows and the trends shaping this outlook, there emerged 10 key findings that guide the strategy. These findings made significant contributions to the definition of quality FDI profiles for Türkiye and the design of the policy areas put forward within the scope of the strategy.",
        "slides": [
            {
                "id": "slide1",
                "number": "01",
                "heading": "While global FDI flows have remained stagnant, there has been a significant increase in FDI inflows into the region where Türkiye is also located.",
                "description": "Türkiye has emerged as one of the most appealing investment destinations in CEEMENA over the last 20 years. Türkiye is expected to further strengthen its leading position in the coming period.",
                "image": "/images/0-new-rising-trend.avif"
            },
            {
                "id": "slide2",
                "number": "02",
                "heading": "High value-added service sector investments in CEEMENA have been on an upward trend in recent years.",
                "description": "As the leader in medium-high-tech manufacturing investments in CEEMENA, Türkiye is likely to benefit from the opportunities emerging in high value-added service sector investments in the mid-term future.",
                "image": "/images/city-service-network_1.avif"
            },
            {
                "id": "slide3",
                "number": "03",
                "heading": "The fight against climate change and sustainability concerns has become one of the most significant factors influencing global FDI flows.",
                "description": "Green energy, ESG standards, and sustainability are key for attracting international investors. Türkiye can enhance its appeal by improving green transformation, boosting investments in manufacturing and digital sectors.",
                "image": "/images/GlobalFDI-Trend-05_1.webp"
            },
            {
                "id": "slide4",
                "number": "04",
                "heading": "Nearshoring and friend-shoring trends are gaining importance in the transformation of global value chains and these trends deeply affect global FDI.",
                "description": "Türkiye’s production, talent, and market access make it well-positioned for growth. Aligning with international standards and improving the investment environment can boost its role in R&D and design, strengthening its global value chain position.",
                "image": "/images/GlobalFDI-Trend-01.webp"
            },
            {
                "id": "slide5",
                "number": "05",
                "heading": "Rapid growth in digital sectors and digitalization trends in traditional sectors are emerging as significant factors affecting global FDI flows.",
                "description": "Türkiye can boost its market share by enhancing STEM education, improving digital skills, aligning data policies with international standards, and strengthening digital infrastructure.",
                "image": "/images/GlobalFDI-Trend-06_1.webp"
            },
            {
                "id": "slide6",
                "number": "06",
                "heading": "In recent years, protectionist measures, evident in trade and technology conflicts, have begun to affect global FDI flows more profoundly, a trend that has intensified after the pandemic outbreak.",
                "description": "Restrictive policies applied to both inward and outward FDI can create obstacles in many countries, particularly for investors in high-technology sectors. Türkiye, with its investor-friendly environment, can turn this challenge into an opportunity.",
                "image": "/images/GlobalFDI-Trend-02_1.webp"
            },
            {
                "id": "slide7",
                "number": "07",
                "heading": "The number of mega-projects is rapidly increasing on a global scale. CEEMENA in which Türkiye is located is one of the most outstanding destinations for such investments.",
                "description": "Türkiye can attract more mega projects by promoting its incentives, developing large-scale industrial areas, and streamlining bureaucracy.",
                "image": "/images/new-construction.avif"
            },
            {
                "id": "slide8",
                "number": "08",
                "heading": "Türkiye is the top country attracting the most expansion investments in CEEMENA.",
                "description": "Existing investors are expanding their investments in Türkiye, capitalizing on the country's opportunities. Promoting this positive perception globally can attract more greenfield investments. Additionally, retaining current investors is key to encouraging further expansion.",
                "image": "/images/GlobalFDI-Trend-07_1.webp"
            },
            {
                "id": "slide9",
                "number": "09",
                "heading": "International investors play a notable role in making Türkiye an outstanding production and export hub in CEEMENA.",
                "description": "International companies account for about 30% of Türkiye's exports, excelling in medium high-tech but lagging slightly in high-tech exports. Türkiye can boost its high-tech exports by attracting more export-oriented investments.",
                "image": "/images/1-shipment_reduced_1.webp"
            },
            {
                "id": "slide10",
                "number": "10",
                "heading": "Investments in startups have recently become a significant component of global FDI.",
                "description": "Türkiye's tech startups have made significant progress, becoming a top CEEMENA destination for investments. Strengthening the startup ecosystem will attract more high-quality financial FDI.",
                "image": "/images/GlobalFDI-Trend-08_1.webp"
            }
        ]
    },
    "insightHeroSection": {
        "tagline": "FDI STRATEGY",
        "heading": "The Primary Goal and Policy Areas of the Strategy",
        "description": "To achieve these targets, six main policy areas have been identified, considering the global trends affecting FDI and the site selection criteria of international investors."
    },
    "actionPlanHero": {
        "tagline": "FDI STRATEGY",
        "heading": "Action Plan – 2026",
        "className": "cover-image action-plans",
        "id": "w-node-_8ef79bb6-13fa-f9cf-d760-5293f3e0cc60-e090c599",
        "paragraph": "Actions include enhancing investment attraction performance in high-quality FDI profiles and setting specific targets for each profile.",
        "downloadButton": {
            "text": "Download Action Plan",
            "link": "https://www.invest.gov.tr/en/Documents/national-fdi-strategy-action-plan-2026.pdf"
        },
        "archiveButton": {
            "text": "Previous Action Plans",
            "tableHeaders": {
                "year": "Year",
                "title": "Title",
                "download": "Download"
            }
        },
        "archivePlans": [
            {
                "year": "2024",
                "title": "FDI Strategy Action Plans 2024",
                "link": "https://www.invest.gov.tr/en/Documents/archive/turkiye-fdi-strategy-action-plans-2024.pdf?download"
            }
        ],
        "image": {
            "src": "/images/6673c8c43f29cec166d3ab6b_fdi-action-plans-cover.webp",
            "alt": "cover-visual",
            "srcset": "/images/6673c8c43f29cec166d3ab6b_fdi-action-plans-cover-p-500.webp 500w, /images/6673c8c43f29cec166d3ab6b_fdi-action-plans-cover-p-800.webp 800w, /images/6673c8c43f29cec166d3ab6b_fdi-action-plans-cover.webp 1600w"
        }
    },
    "actionPlanData": {
        "actions": [
            {
                "action_no": "1.1.1",
                "action": "Facilitating and incentivizing measures will be implemented to attract the Shared Service Centers (SSCs) of international companies to our country.",
                "description": "In addition to existing incentive mechanisms, new practices will be developed to attract Shared Service Center (SSC) investments from multinational companies to our country.",
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "Ministry of Industry and Technology,Ministry of Trade,NGOs within the scope of YOİKK"
            },
            {
                "action_no": "1.1.2",
                "action": "A strategic prioritization study will be conducted regarding long-term investment loans.",
                "description": "Strategic prioritization will be conducted in the Central Bank of Türkiye's Investment Commitment Advance Loan (YTAK) program to enhance access to financing opportunities.",
                "responsible_institution": "Central Bank of Republic of Türkiye",
                "related_institutions": "Ministry of Treasury and Finance,Ministry of Industry and Technology,Ministry of Trade,Presidency of Strategy And Budget,Institutions,Organizations and NGOs within the scope of YOİKK"
            },
            {
                "action_no": "1.1.3",
                "action": "Incentive mechanisms to accelerate the green and digital transformation of the industry will be implemented.",
                "description": "National incentive mechanisms will be replanned with a focus on the twin transformation initiative.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "Ministry of Treasury and Finance,Ministry of Trade,Presidency of Strategy And Budget,Institutions,Organizations and NGOs within the scope of YOİKK"
            },
            {
                "action_no": "1.2.1",
                "action": "\nAn investment sites inventory, including suitable investment lands for investors to benefit from, will be created.",
                "description": "Suitable lands for quality investments will be identified in selected pilot provinces.",
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "Ministry of Environment, Urbanisation and Climate Change, Ministry of Industry and Technology"
            },
            {
                "action_no": "1.2.2",
                "action": "An effective coordination mechanism will be established in the investment land allocation processes, and new allocation models that ensure faster processing of strategic and large-scale investments will be developed.",
                "description": "A report identifying and proposing recommendations for reducing bureaucracy and updating regulations related to investment land allocation mechanisms will be prepared.",
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "Ministry of Environment, Urbanisation and Climate Change, Ministry of Industry and Technology"
            },
            {
                "action_no": "1.3.1",
                "action": "Regulations will be implemented to promote the widespread use of equity-based long-term incentives for technology start-up companies.",
                "description": "Long-term incentive systems will be established to encourage employees, especially those working in the technology sector.",
                "responsible_institution": "Ministry of Treasury and Finance",
                "related_institutions": "Revenue Administration,Ministry of Industry and Technology,Institutions,Organizations and NGOs within the scope of YOİKK"
            },
            {
                "action_no": "1.3.2",
                "action": "The overseas investment limit for Venture Capital Investment Funds (VCIF) will be increased.",
                "description": "A regulation will be implemented to amend the maximum 10% limit stipulated in Article 23 of the Communiqué on Principles Regarding Venture Capital Investment Funds.",
                "responsible_institution": "Ministry of Treasury and Finance",
                "related_institutions": "Ministry of Industry and Technology,Institutions,Organizations and NGOs within the scope of YOİKK"
            },
            {
                "action_no": "1.4.1",
                "action": "Implementing institutions will ensure the minimization of procedures identified in the Investment Processes Guide that cause time loss.",
                "description": "1. Simplifiable aspects of the procedures outlined in the Investment Processes Guide will be identified in collaboration with private sector umbrella organizations.\n2. Reform areas will be identified and an annual action plan will be prepared for the topics covered by the Business Ready Project, developed by the World Bank to analyze the business and investment environment of 180 countries.",
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "Related Institutions and Organizations"
            },
            {
                "action_no": "1.5.1",
                "action": "Alternative resolution mechanisms will be developed to ensure that investment disputes between investors and public institutions are resolved through reconciliation in the fastest and most cost-effective manner.",
                "description": "\n1. A comprehensive commission will be established to conduct a needs analysis and carry out the necessary studies.\n2. Legislative preparation work for the implementation of an effective administrative reconciliation procedure will be completed.",
                "responsible_institution": "Ministry of Justice",
                "related_institutions": "Ministry of Industry and Technology,Investment Office of Türkiye,Presidency of Strategy And Budget"
            },
            {
                "action_no": "1.5.2",
                "action": "A regulatory study will be conducted to standardize the appeal, objection, and cassation application periods, ensuring these periods commence from the date of notification.",
                "description": "The legislative amendment work conducted by the Ministry of Justice will be completed with contributions from relevant institutions and organizations.",
                "responsible_institution": "Ministry of Justice",
                "related_institutions": "Ministry of Interior,Ministry of Treasury and Finance,Ministry of Family and Social Services,Ministry of Environment, Urbanisation and Climate Change, Presidency of Strategy And Budget,General Directorate of Personnel and Principles"
            },
            {
                "action_no": "1.6.1",
                "action": "R&D laboratories established in Türkiye by leading national or international firms producing pioneering scientific and technological knowledge in their fields will be supported.",
                "description": "R&D activities within the TRL (Technological Readiness Level) 1-4 range will be supported under the Pioneering R&D Laboratories Support Program.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "The Scientific and Technological Research Council of Türkiye (TÜBİTAK)"
            },
            {
                "action_no": "2.1.1",
                "action": "Efforts will be undertaken to develop investments and technologies for hydrogen fuel cells and components, as well as hydrogen-based engines.",
                "description": "1. A 100 kW fuel cell module will be produced, and development efforts for modules\/systems of different capacities for various application areas will be carried out.\n2. Necessary work will be conducted within the scope of the Type Approval Regulations.\n3. Efforts will be made to develop hydrogen storage, refueling, and fuel cell systems for cargo vehicles.\n4. Work will be conducted under the Hydrogen-Based Carbon-Neutral Internal Combustion Engine Development Project.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "Ministry of Energy and Natural Resources,The Scientific and Technological Research Council of Türkiye (TÜBİTAK),Relevant Private Sector Organizations"
            },
            {
                "action_no": "2.1.2",
                "action": "The need for legislative changes to enable the establishment of additional capacities based on renewable energy sources will be presented to the Turkish Grand National Assembly (TBMM).",
                "description": "The need for a regulation related to Law No. 3621 on the Coastline will be presented to the Turkish Grand National Assembly (TBMM) to enable the installation of Solar Power Plants (SPPs) on natural and artificial lakes.",
                "responsible_institution": "Ministry of Energy and Natural Resources",
                "related_institutions": "Ministry of Environment, Urbanisation and Climate Change, Ministry of Agriculture and Forestry,Presidency of Strategy And Budget,Institutions,Organizations and NGOs within the scope of YOİKK"
            },
            {
                "action_no": "2.1.3",
                "action": "New Renewable Energy Resource Area (YEKA) tenders with local component obligations will be conducted, and efforts will be undertaken to develop offshore YEKA projects.",
                "description": "1. At least one Renewable Energy Resource Area (YEKA) competition will be held.\n2. At least one offshore wind power plant site will be identified.",
                "responsible_institution": "Ministry of Energy and Natural Resources",
                "related_institutions": null
            },
            {
                "action_no": "2.1.4",
                "action": "Treasury lands that can be allocated for renewable energy investments will be determined on a regional and sectoral basis, considering environmental and social impacts as well as logistical requirements within the framework of our country's long-term investment needs.",
                "description": "Treasury lands will be announced for the establishment of unlicensed Wind Energy Plants (WPP) and Solar Power Plants (SPP).",
                "responsible_institution": "Ministry of Environment,Urbanization and Climate Change",
                "related_institutions": "Ministry of Energy and Natural Resources,Ministry of Culture and Tourism,Ministry of Industry and Technology"
            },
            {
                "action_no": "2.2.1",
                "action": "Necessary measures will be taken to minimize the harmful effects of all waste on human health and the environment by controlling emissions into the air, water, and soil.",
                "description": "Secondary legislation for managing industrial emissions using best practices will be prepared.",
                "responsible_institution": "Ministry of Environment,Urbanization and Climate Change",
                "related_institutions": "Ministry of Industry and Technology"
            },
            {
                "action_no": "2.2.2",
                "action": "A National Circular Economy Action Plan will be prepared.",
                "description": "An action plan will be prepared to ensure the effective implementation of circular economy principles on a national scale.",
                "responsible_institution": "Ministry of Environment,Urbanization and Climate Change",
                "related_institutions": "Ministry of Industry and Technology,Relevant Public Institutions and Organizations,Local Administrations"
            },
            {
                "action_no": "2.3.1",
                "action": "Standardization will be ensured in the presentation of sustainability and emission data, and this data will be made available for sharing.",
                "description": "1. Türkiye Sustainability Reporting Standards will be prepared in alignment with international standards, and two sustainability reporting standards along with an additional 68 sector-based sustainability reporting standards will be published.\n2. The Sustainability Principles Compliance Framework, included in the appendix of the Corporate Governance Communiqué, will be updated to align with international standards, enabling investors and companies to monitor sustainability risks and opportunities.",
                "responsible_institution": "Ministry of Treasury and Finance",
                "related_institutions": "Ministry of Environment,Urbanization and Climate Change"
            },
            {
                "action_no": "2.3.2",
                "action": "A national taxonomy and relevant legislation for defining sustainable economic activities will be prepared.",
                "description": "Legislative work will be carried out to create a National Green Taxonomy that is aligned with international taxonomy examples, particularly the EU taxonomy, while considering Türkiye's needs.",
                "responsible_institution": "Ministry of Environment,Urbanization and Climate Change",
                "related_institutions": "Ministry of Treasury and Finance"
            },
            {
                "action_no": "2.3.3",
                "action": "The preparation of fundamental legislation addressing climate change practices in a holistic manner will be completed.",
                "description": "Climate legislation preparations will be completed.",
                "responsible_institution": "Ministry of Environment,Urbanization and Climate Change",
                "related_institutions": "Directorate of Climate Change,Relevant Public Institutions and Organizations"
            },
            {
                "action_no": "2.4.1",
                "action": "R&D activities and technology transfer will be supported to adopt, develop, and disseminate sustainable production and green transformation technologies.",
                "description": "Activities in this area will be supported through the Green Transformation in Industry Call and the SAYEM Green Transformation Call, which will be launched as part of the Türkiye Green Industry Project.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "Ministry of Environment, Urbanisation and Climate Change, Ministry of Energy and Natural Resources"
            },
            {
                "action_no": "2.4.2",
                "action": "Sectoral needs for green and digital transformation will be identified, and necessary investments will be encouraged.",
                "description": "1. A list of products to be supported under the Digital Transformation Support Program will be prepared.\n2. Investments in green and digital transformation have been prioritized, and green and digital transformation investments will be encouraged by completing the necessary legislative work, including identifying sectoral needs.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "Relevant Public Institutions and Organizations"
            },
            {
                "action_no": "2.5.1",
                "action": "Energy efficiency investments will be supported, prioritizing energy-intensive sectors, with consideration for competitiveness and local production.",
                "description": "1. Legislative regulations will be made to increase the amount of support for energy efficiency.\n2. Legislative regulations will be made to prioritize technological investments with high energy efficiency and savings potential through the support provided.",
                "responsible_institution": "Ministry of Energy and Natural Resources",
                "related_institutions": "Ministry of Industry and Technology"
            },
            {
                "action_no": "2.5.2",
                "action": "Facilities that report reducing their emissions and conducting energy and resource-efficient production towards the zero pollution goal will be certified to demonstrate their clean production.",
                "description": "As part of the harmonization efforts for the 2010\/75\/EU Industrial Emissions Directive, a Green Transformation in Industry Certificate system, equivalent to the EU Integrated Pollution Prevention and Control (IPPC) Certificate, will be established.",
                "responsible_institution": "Ministry of Environment,Urbanization and Climate Change",
                "related_institutions": "Ministry of Energy and Natural Resources,Ministry of Industry and Technology"
            },
            {
                "action_no": "2.6.1",
                "action": "To maintain and enhance competitiveness in foreign trade, national carbon pricing mechanisms will be established, with a priority on implementing an Emissions Trading System (ETS) aligned with the EU.",
                "description": "1. A national carbon pricing mechanism will be established.\n2. An Emissions Trading System (ETS) aligned with the EU will be implemented.",
                "responsible_institution": "Ministry of Environment,Urbanization and Climate Change",
                "related_institutions": "Ministry of Trade"
            },
            {
                "action_no": "2.6.2",
                "action": "Impact investment tools such as social impact bonds and blue bonds will be developed and their usage will be promoted to generate social and environmental benefits in addition to economic gains.",
                "description": "1. An Impact Fund will be established under the Türkiye Development Fund, supporting companies that sustainably address social issues, including firms in earthquake-affected areas.\n2. Studies will be conducted on providing tax incentives for investment funds that invest in sustainable financial instruments.",
                "responsible_institution": "Ministry of Treasury and Finance",
                "related_institutions": null
            },
            {
                "action_no": "3.1.1",
                "action": "Efforts to align the Personal Data Protection Law with the European Union acquis, particularly the EU General Data Protection Regulation (GDPR), will be completed.",
                "description": "Efforts to align Law No. 6698 on the Protection of Personal Data with the European Union General Data Protection Regulation (GDPR) will be completed.",
                "responsible_institution": "Ministry of Justice",
                "related_institutions": "Ministry of Industry and Technology,Ministry of Trade"
            },
            {
                "action_no": "3.1.2",
                "action": "Regulations will be implemented to ensure national cybersecurity, taking into account the EU's Network and Information Security Directive (NIS2), new cybersecurity initiatives, and international best practices.",
                "description": "1. A regulation will be published to ensure national cybersecurity and enhance cyber deterrence.\n2. Regulatory work will be conducted on the security of the Internet of Things (IoT).\n3. Cybersecurity scans will be performed on IoT devices.\n4. Necessary secondary regulations will be identified in relation to the ongoing preparation of the national cybersecurity framework legislation.\n5. Studies will be conducted on Law No. 5070 on Electronic Signatures and other relevant legislation to establish the legal framework for remote signature services.\n6. Awareness campaigns will be carried out to promote the use of remote signature services in public institutions and the private sector.",
                "responsible_institution": "Ministry of Transportation and Infrastructure",
                "related_institutions": "Ministry of Industry and Technology,Information Technologies and Communications Institution,Personal Data Protection Authority,Relevant Public Institutions and Organizations"
            },
            {
                "action_no": "3.1.3",
                "action": "The need for amendments to Law No. 6698 on the Protection of Personal Data will be presented to the Turkish Grand National Assembly (TBMM).",
                "description": "The need for legislative amendments to align Law No. 6698 on the Protection of Personal Data with the EU General Data Protection Regulation (GDPR) (Article 6: Conditions for processing special categories of personal data and Article 9: Transfer of personal data abroad) will be presented to the Turkish Grand National Assembly (TBMM).",
                "responsible_institution": "Ministry of Justice",
                "related_institutions": "Ministry of Foreign Affairs,Ministry of Industry and Technology,Ministry of Trade,Presidency of Strategy And Budget,Investment Office of Türkiye,Digital Transformation Office,Institutions,Organizations and NGOs within the scope of YOİKK"
            },
            {
                "action_no": "3.2.1",
                "action": "Mechanisms will be established to encourage the development of local firms providing data center services and to enhance competition.",
                "description": "1. A regulatory framework study will be conducted to facilitate the development of the data center sector.\n2. Legislation will be enacted to promote the development of the data center, cloud computing, and platform services sectors.",
                "responsible_institution": "Ministry of Transportation and Infrastructure",
                "related_institutions": "Ministry of Industry and Technology,Information Technologies and Communications Institution,Personal Data Protection Authority,The Scientific and Technological Research Council of Türkiye (TÜBİTAK),Ministry of Justice,Ministry of Treasury and Finance,Presidency of Strategy And Budget"
            },
            {
                "action_no": "3.2.2",
                "action": "The local production of 5G base stations will be supported, and their installation will be expanded to address infrastructure deficiencies.",
                "description": "R&D supports provided or to be provided for 5G will be identified, and the developed products will be used in commercial and universal networks.",
                "responsible_institution": "Ministry of Transportation and Infrastructure",
                "related_institutions": "Ministry of Industry and Technology"
            },
            {
                "action_no": "3.2.3",
                "action": "Broadband infrastructure installation will be encouraged in regions where infrastructure development has been lacking, taking regional differences into account.",
                "description": "A report will be prepared to identify areas anticipated for support in terms of fiber infrastructure, conduct relevant impact analysis studies, propose alternatives for support and incentive methods, and determine the costs.",
                "responsible_institution": "Ministry of Transportation and Infrastructure",
                "related_institutions": "Information Technologies and Communications Institution"
            },
            {
                "action_no": "3.3.1",
                "action": "Efforts will be made to develop devices and applications that meet the end-to-end requirements of vertical sectors such as industry, agriculture, transportation, and energy in 5G and beyond technologies.",
                "description": "Activities planned under the BEYOND5 RFSOI-Based European Supply Chain Establishment and 5G-Mobix projects will be carried out within the scope of 5G, 6G, and beyond communication technologies.",
                "responsible_institution": "Ministry of Transportation and Infrastructure",
                "related_institutions": null
            },
            {
                "action_no": "3.3.2",
                "action": "An Open Source Software Cluster will be established.",
                "description": "1. An inventory of companies, NGOs, and universities operating in the field of open-source software will be compiled.\n2. Workshops will be organized to establish horizontal cooperation among companies in the open-source software field and to identify pre-competitive collaboration activities.\n3. Training and awareness programs will be organized to promote the use of open-source software.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "Digital Transformation Office,The Scientific and Technological Research Council of Türkiye (TÜBİTAK)"
            },
            {
                "action_no": "3.3.3",
                "action": "Priority will be given to training a skilled workforce in software, hardware, and infrastructure for 5G and beyond new generation communication technologies, as well as in emerging technology fields such as the Internet of Things, artificial intelligence, big data, quantum computing, cybersecurity, smart transportation, and augmented reality.",
                "description": "Higher education programs in artificial intelligence, big data, and cybersecurity will be established.",
                "responsible_institution": "Council of Higher Education",
                "related_institutions": "Universities"
            },
            {
                "action_no": "4.1.1",
                "action": "Legislative work will be conducted to improve the competitive environment in digital markets.",
                "description": "The need for amendments to Law No. 4054 on the Protection of Competition related to digital markets will be presented to the Turkish Grand National Assembly (TBMM).",
                "responsible_institution": "Ministry of Trade",
                "related_institutions": "Competition Authority,Digital Transformation Office,Information Technologies and Communications Institution,Personal Data Protection Authority,Institutions,Organizations and NGOs within the scope of YOİKK"
            },
            {
                "action_no": "4.1.2",
                "action": "\nThe dimensions of EU digital economy regulations that affect our country's trade and the necessary steps to be taken will be identified.",
                "description": "A report and roadmap will be created to take precautions against the risk of recent EU legislation in the digital economy posing trade barriers for our country.",
                "responsible_institution": "Ministry of Trade",
                "related_institutions": "Ministry of Transportation and Infrastructure,Digital Transformation Office,Institutions,Organizations and NGOs within the scope of YOİKK"
            },
            {
                "action_no": "4.2.1",
                "action": "Our country's preferential trade network will be strengthened, new free trade agreements will be negotiated, and efforts will be made to expand the scope of existing free trade agreements.",
                "description": "1. Türkiye-Japan Free Trade Agreement (FTA) negotiations will continue.\n2. Türkiye-Thailand Free Trade Agreement (FTA) negotiations will continue.",
                "responsible_institution": "Ministry of Trade",
                "related_institutions": "Ministry of Foreign Affairs"
            },
            {
                "action_no": "4.2.2",
                "action": "Negotiations for updating the Customs Union will be conducted, and national negotiation preparations will be completed by gathering opinions from the public sector, private sector, NGOs, and academics.",
                "description": "Meetings will be organized with the participation of representatives from the public sector, private sector, NGOs, and academia to formulate the negotiation position.",
                "responsible_institution": "Ministry of Trade",
                "related_institutions": "Ministry of Foreign Affairs,Relevant Public Institutions and Organizations"
            },
            {
                "action_no": "4.3.1",
                "action": "Green port practices will continue to be supported by encouraging the use of low-emission or emission-free machinery and equipment to increase energy efficiency and minimize environmental impacts in port operations.",
                "description": "Regulations regarding the issuance of green port certificates to coastal facilities will be implemented.",
                "responsible_institution": "Ministry of Transportation and Infrastructure",
                "related_institutions": "Ministry of Industry and Technology"
            },
            {
                "action_no": "4.3.2",
                "action": "Infrastructure and technology investments will be made to enable the use of electric or other alternative fuel vehicles across all modes of transportation, and regulatory adjustments for next-generation, sustainable, integrated mobility services will be completed.",
                "description": "Charging station energy infrastructures will be developed in ports, train stations, and on highways, and the relevant regulatory arrangements will be completed.",
                "responsible_institution": "Ministry of Energy and Natural Resources",
                "related_institutions": "Ministry of Industry and Technology,Ministry of Transportation and Infrastructure"
            },
            {
                "action_no": "4.3.3",
                "action": "Efforts to increase the efficiency and diversity of the transportation corridors in which our country is located will continue to ensure the sustainability of the global supply chain.",
                "description": "\nThe Project to Strengthen Intermodal Transportation Services in the Turkish Railway Sector will be completed.",
                "responsible_institution": "Ministry of Transportation and Infrastructure",
                "related_institutions": "Ministry of Trade"
            },
            {
                "action_no": "4.3.4",
                "action": "A main port will be constructed in the Eastern Mediterranean region to serve as the gateway for Middle Eastern and Central Asian countries, focusing on transit cargo and contributing to the region's development and export growth.",
                "description": "Site selection and feasibility studies for the construction of a main port will be completed.",
                "responsible_institution": "Ministry of Transportation and Infrastructure",
                "related_institutions": "-"
            },
            {
                "action_no": "4.3.5",
                "action": "New industrial zones and logistics lines will be established with consideration of disaster risks, and the connections between industrial zones and ports (including RoRo) will be strengthened by utilizing the existing railway infrastructure more effectively.",
                "description": "-",
                "responsible_institution": "Ministry of Transportation and Infrastructure",
                "related_institutions": "-"
            },
            {
                "action_no": "4.4.1",
                "action": "SMEs will be encouraged to cluster around large-scale firms to strengthen the local supply chain.",
                "description": "To bring together large enterprises in priority sectors with potential suppliers, matchmaking activities will be conducted to ensure the production of prioritized localization product lists by local suppliers, thereby increasing the number of local suppliers.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "-"
            },
            {
                "action_no": "4.4.2",
                "action": "Matchmaking will be facilitated to integrate SMEs into the supply chains of major industrial manufacturers and large enterprises, and necessary quality, efficiency, and capacity improvements, along with product development (R&D) activities, will be supported as part of supplier development processes.",
                "description": "\n1. The Supplier Digital Database will be made available for businesses to utilize.\n2. Large enterprises seeking localization and SMEs responding to these requests will be brought together through the Supplier Digital Database.\n3. Additional support elements and advantages will be provided in existing support programs to aid the suppliers of large enterprises within the scope of supplier development activities.\n4. Collaboration with institutions\/organizations will be established to support suppliers' R&D, product development, and innovation activities.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "Ministry of Treasury and Finance,Ministry of Trade"
            },
            {
                "action_no": "4.5.1",
                "action": "Paperless customs procedures will be promoted in foreign trade transactions using innovative technologies such as blockchain and optical character recognition (OCR).",
                "description": "1. Studies will be conducted on the use of blockchain (Export Chain) in the BILGE system.\n2. Technical work will be carried out to transition to paperless customs procedures for imports.",
                "responsible_institution": "Ministry of Trade",
                "related_institutions": "-"
            },
            {
                "action_no": "4.5.2",
                "action": "Efforts to use blockchain technology in export transactions will be expanded to include the Computerized Customs Activities (BILGE) System.",
                "description": "The Export Chain Project will be implemented to enable all customs and logistics processes related to export transactions to be conducted and monitored electronically from a single screen by all stakeholders using blockchain infrastructure.",
                "responsible_institution": "Ministry of Trade",
                "related_institutions": "-"
            },
            {
                "action_no": "4.6.1",
                "action": "The Industrial Innovation Network Mechanism Program, which supports high-tech product development (R&D) and commercialization through firm partnerships, especially in priority sectors, will be expanded.",
                "description": "Activities in this area will be supported through the Green Transformation in Industry Call and the SAYEM Green Transformation Call, which will be launched as part of the Türkiye Green Industry Project.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "The Scientific and Technological Research Council of Türkiye (TÜBİTAK),Universities"
            },
            {
                "action_no": "5.1.1",
                "action": "Measures will be taken to employ software developers working remotely or onsite abroad in a way that increases the added value of the local IT sector.",
                "description": "A new software developer incentive program will be implemented for recent graduates from relevant university departments who work at the same company for a certain period.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "Ministry of Treasury and Finance,Digital Transformation Office,Human Resources Office"
            },
            {
                "action_no": "5.1.2",
                "action": "\nUnder the twin transformation initiative, skills needed for specific professions will be identified, and training content\/modules considering these skills will be developed, on-the-job training programs and vocational training courses will be conducted.",
                "description": "1. The skills required for professions regarding the twin transformation will be identified through collaborative efforts.\n2. Educational content and modules that consider the identified skills for relevant professions regarding the twin transformation will be developed in coordination with the Council of Higher Education (YOK).\n3. On-the-job training programs and vocational training courses will be conducted in collaboration with the Turkish Confederation of Employer Associations (TISK) and the Union of Chambers and Commodity Exchanges of Türkiye (TOBB), based on the developed educational modules.",
                "responsible_institution": "Ministry of Labour and Social Security",
                "related_institutions": "Turkish Employment Agency"
            },
            {
                "action_no": "5.1.3",
                "action": "Remote working practices will continue in R&D and Design Centers and Technology Development Zones.",
                "description": "The right to remote work provided to employees of R&D and Design Centers and Technology Development Zones will be maintained, allowing for 100% remote work on a continuous basis, especially for those working in digital technologies.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "Ministry of Treasury and Finance,Presidency of Strategy And Budget,Institutions,Organizations and NGOs within the scope of YOİKK"
            },
            {
                "action_no": "5.2.1",
                "action": "To increase the number of qualified personnel with research experience, more undergraduate, master's, and doctoral fellows will be involved in publicly supported R&D projects.",
                "description": "1. To encourage the participation of doctoral students in R&D projects, the Postgraduate Scholarships Performance Program will be opened for calls twice a year, and the application and support processes will be managed accordingly.\n2. The Intern Researcher Scholarship Program will be opened for calls twice a year, and bursars supported under the program will be ensured participation in projects.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "Council of Higher Education,The Scientific and Technological Research Council of Türkiye (TÜBİTAK),Universities"
            },
            {
                "action_no": "5.2.2",
                "action": "Qualified researchers conducting high-level scientific and technological studies will continue to be supported through special programs.",
                "description": "1. The International Leading\/Young Researchers Programs will be opened for calls, and the application, support, and monitoring processes will be managed.\n2. The National Leading Researchers Program and the National Young Leaders Programs will be opened for calls, and the application, support, and monitoring processes will be managed.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "Council of Higher Education,The Scientific and Technological Research Council of Türkiye (TÜBİTAK),Universities"
            },
            {
                "action_no": "5.2.3",
                "action": "The training of qualified personnel with doctoral degrees needed in the industry will be ensured through university-industry collaboration, and the employment of doctoral researchers will be encouraged.",
                "description": "Doctoral students will be supported under the Industry PhD Program, and the employment of doctoral researchers in the industry will be encouraged.",
                "responsible_institution": "Ministry of Industry and Technology",
                "related_institutions": "Council of Higher Education,The Scientific and Technological Research Council of Türkiye (TÜBİTAK),Universities"
            },
            {
                "action_no": "5.2.4",
                "action": "The amount of postgraduate scholarships for basic sciences and the number of recipients will be increased.",
                "description": "Under the Young Minds in Basic Sciences Project, research assistants in the thesis stage of their doctoral education in physics, chemistry, biology, or mathematics at state universities will be provided with scholarship support to conduct research abroad.",
                "responsible_institution": "Council of Higher Education",
                "related_institutions": "Universities"
            },
            {
                "action_no": "5.3.1",
                "action": "Education will be provided in foreign languages according to international standards, ensuring that students acquire advanced reading, comprehension, speaking, and writing skills.",
                "description": "1. Language education policies will be aligned with current approaches to enhance listening, speaking, reading, and writing skills, in-service training on the language proficiency framework used in curricula will be conducted to improve teachers' knowledge and skills.\n2. To develop students' foreign language skills, the foreign language preparatory classes for fifth graders will be structured in English and German, and a pilot implementation will be conducted in selected schools during the 2023-2024 academic year.\n3. Materials for language education will be enriched, and a system will be developed to assess all skills in listening, speaking, reading, and writing.",
                "responsible_institution": "Ministry of National Education",
                "related_institutions": null
            },
            {
                "action_no": "5.4.1",
                "action": "Collaboration protocols will be established between vocational and technical education institutions and Organized Industrial Zones.",
                "description": "1. Efforts will be made to ensure that the planning of Organized Industrial Zones (OIZs) during their establishment phase includes boarding vocational and technical secondary education institutions, and to standardize this practice.\n2. In OIZs that do not yet have vocational and technical secondary education institutions, boarding school buildings will be constructed in cooperation with the Ministry of National Education, and these schools will operate under the Ministry of National Education or the OIZ management.",
                "responsible_institution": "Ministry of National Education",
                "related_institutions": "Organized Industrial Zones Supreme Organization,Chambers of Commerce and Industry,Institutions,Organizations and NGOs within the scope of YOİKK"
            },
            {
                "action_no": "5.4.2",
                "action": "Vocational and technical education institutions will be paired with private sector organizations, particularly Industrial and Commercial Chambers and Organized Industrial Zone administrations, to create sectoral clusters in vocational education.",
                "description": "1. Efforts will be made to ensure that the planning of Organized Industrial Zones (OIZs) during their establishment phase includes boarding vocational and technical secondary education institutions, and to standardize this practice.\n2. In OIZs that do not yet have vocational and technical secondary education institutions, boarding school buildings will be constructed in cooperation with the Ministry of National Education, and these schools will operate under the Ministry of National Education or the OIZ management.",
                "responsible_institution": null,
                "related_institutions": "Organized Industrial Zones Supreme Organization,Chambers of Commerce and Industry,Institutions,Organizations and NGOs within the scope of YOİKK"
            },
            {
                "action_no": "5.5.1",
                "action": "A visa model for early-stage entrepreneurs will be established, along with support and regulations to attract international entrepreneurs to Türkiye.",
                "description": "Activities for a visa model for early-stage entrepreneurs will continue, and the necessary support and regulations will be implemented.",
                "responsible_institution": "Ministry of Labour and Social Security",
                "related_institutions": "Ministry of Interior,Ministry of Industry and Technology"
            },
            {
                "action_no": "5.5.2",
                "action": "Priority and ease will be provided in granting residence and work permits to foreign nationals and their families who come to the country for conducting R&D or product development activities, making investments, managing, or operating businesses.",
                "description": "A research study will be conducted to analyze the effects of remote working, brought about by technological transformation and digitalization, on sectoral, occupational, and regional labor migration.",
                "responsible_institution": "Ministry of Labour and Social Security",
                "related_institutions": "Ministry of Interior,Ministry of Industry and Technology"
            },
            {
                "action_no": "5.5.3",
                "action": "Efforts will be made to encourage and facilitate the employment of qualified foreign doctoral researchers and academics.",
                "description": "The employment of foreign doctoral international scientists in needed fields will be supported.",
                "responsible_institution": "Council of Higher Education",
                "related_institutions": "Universities"
            },
            {
                "action_no": "5.6.1",
                "action": "The skills of the existing workforce will be supported and enhanced, and those not currently in the workforce will be equipped with the skills needed by the industry through public-private collaboration.",
                "description": "Vocational training courses and on-the-job training programs will be organized for 40,000 people within the scope of active labor market programs aimed at strengthening the alignment between labor supply and the needs of the labor market in the industrial sector.",
                "responsible_institution": "Ministry of Labour and Social Security",
                "related_institutions": "Ministry of Industry and Technology"
            },
            {
                "action_no": "5.6.2",
                "action": "The effectiveness of programs aimed at supporting the employment of young people who are neither in education nor in employment will be enhanced.",
                "description": "The ISKUR youth website, which aims to consolidate the services provided to young people by ISKUR under one roof and allow them to access these services from a single platform, will be launched and its use will be promoted.",
                "responsible_institution": "Ministry of Labour and Social Security",
                "related_institutions": "Turkish Employment Agency,Ministry of Education"
            },
            {
                "action_no": "5.6.3",
                "action": "In collaboration with central and local governments, the private sector, and NGOs, alternative models for quality, affordable, and accessible care services will be developed and expanded following pilot implementations to increase female employment.",
                "description": "Work will be carried out to develop alternative models for quality, affordable, and accessible care services in collaboration with central and local governments, the private sector, and NGOs to increase female employment.",
                "responsible_institution": "Ministry of Family and Social Services",
                "related_institutions": "Ministry of Labour and Social Security,Local Administrations,NGOs and Private Sector Organisations"
            },
            {
                "action_no": "6.1.1",
                "action": "Events will be organized, and participation in major events will be ensured to promote Türkiye's investment environment on a national and international scale.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.1.2",
                "action": "A new communication and promotion strategy will be developed and implemented to effectively promote Türkiye's investment environment.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.1.3",
                "action": "Special contents will be produced for communication and promotional activities on conventional, digital, and social media platforms, and the number of language options will be increased.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.2.1",
                "action": "The corporate website invest.gov.tr will be redesigned and relaunched as the main platform to promote Türkiye's value proposition for international direct investment and to guide investors towards opportunities.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.2.2",
                "action": "Corporate identity elements will be updated for the repositioning of the \"Invest in Türkiye\" brand.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.3.1",
                "action": "Sector-specific promotional events will be organized and participation in major events will be ensured in priority countries and regions, specifically targeting quality FDI profiles.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.3.2",
                "action": "Sector reports will be prepared in Turkish and other necessary foreign languages, specifically targeting quality FDI profiles, and these reports will be updated annually.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.3.3",
                "action": "Key messages and unique content (message house) will be crafted for the effective promotion of investment opportunities in Türkiye targeting quality FDI profiles, and dynamic strategies will be developed.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.3.4",
                "action": "A portfolio of 'ready-to-invest' projects (such as PPP, industrial cooperation projects, M&A investments, etc.) will be created for international investors.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.4.1",
                "action": "The technology startup ecosystem of our country and high-growth potential technology startups will be promoted on an international scale.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.4.2",
                "action": "For each quality FDI profile, potential investment areas and prospective investor companies will be identified by country\/region for the 2024-28 period, and activities to attract these investments will be conducted.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.4.3",
                "action": "Targeted investment attraction activities will be carried out to encourage FDI firms operating in Türkiye to expand their investments into higher value-added areas (such as R&D and design centers, regional management centers, shared service centers, regional distribution centers, etc.).",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.5.1",
                "action": "Cooperation and consultation mechanisms will be developed with Turkish executives working in international companies and Turkish entrepreneurs based abroad, and joint activities will be conducted to promote Türkiye's investment environment.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.5.2",
                "action": "Contents showcasing the positive experiences of international investors operating in our country and highlighting Türkiye's value propositions will be prepared and used in promotional activities.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.5.3",
                "action": "Türkiye FDI Strategy and quality FDI profiles will be presented to key stakeholders in the investment ecosystem, including embassies, commercial attachés, development agencies, and other relevant public institutions.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            },
            {
                "action_no": "6.5.4",
                "action": "Communication and cooperation programs will be developed for business organizations based in Türkiye, international organizations, media outlets, and journalists.",
                "description": null,
                "responsible_institution": "Investment Office of Türkiye",
                "related_institutions": "-"
            }
        ],
        "policies": [
            {
                "policy_no": "1.1",
                "policy": "The effectiveness of incentive mechanisms offered to investors will be enhanced to attract quality FDI projects that support the twin (green and digital) transformation of the economy."
            },
            {
                "policy_no": "1.2",
                "policy": "More investment sites will be developed for qualified FDI profiles, taking into account environmental and social impacts and logistical requirements, be presented in digital platforms and land allocation processes will be streamlined."
            },
            {
                "policy_no": "1.3",
                "policy": "In order to strengthen the start-up ecosystem, necessary physical, legal, and digital infrastructure will be further strengthened, and alternative and innovative financing opportunities will be further increased."
            },
            {
                "policy_no": "1.4",
                "policy": "In order to strengthen the start-up ecosystem, necessary physical, legal, and digital infrastructure will be further strengthened, and alternative and innovative financing opportunities will be further increased."
            },
            {
                "policy_no": "1.5",
                "policy": "The regulatory framework in the business and investment environment will be further improved to enhance investor confidence, predictability, and stability."
            },
            {
                "policy_no": "1.6",
                "policy": "Targeted activities will be carried out to increase the local embeddedness of existing international investors in Türkiye, directing them to more value-added areas such as R&D and design, and to increase their expansion investments."
            },
            {
                "policy_no": "2.1",
                "policy": "Measures will be taken to increase renewable energy production, ensure the dissemination of environmentally friendly technologies, and further facilitate investors’ access to green energy."
            },
            {
                "policy_no": "2.2",
                "policy": "Actions will be taken to improve the investment environment focused on circular economy and sustainability, to attract quality FDI projects that support Türkiye’s green transformation process."
            },
            {
                "policy_no": "2.3",
                "policy": "International standards and regulations, especially the EU Green Deal, that support Türkiye’s green transformation will be closely followed, and necessary regulations for production and trade will be implemented."
            },
            {
                "policy_no": "2.4",
                "policy": "Environmentally friendly policies integrated with low-emission and digitized production techniques will be crafted to attract quality FDI projects."
            },
            {
                "policy_no": "2.5",
                "policy": "A favorable investment environment will be ensured to attract technological investments with high energy efficiency and savings potential to Türkiye."
            },
            {
                "policy_no": "2.6",
                "policy": "Efforts will be made to further strengthen the ecosystem that will promote the development of green finance in Türkiye."
            },
            {
                "policy_no": "3.1",
                "policy": "International standards and regulations supporting Türkiye’s digital transformation process will be followed, and necessary regulations for production and trade will be implemented."
            },
            {
                "policy_no": "3.2",
                "policy": "The digital infrastructure of Türkiye will be further strengthened to attract quality FDI projects."
            },
            {
                "policy_no": "3.3",
                "policy": "The ecosystem in emerging technology areas such as 5G and beyond, new generation communication technologies, the Internet of Things, artificial intelligence, big data, quantum computing, cybersecurity, intelligent transportation, and augmented reality will be further developed."
            },
            {
                "policy_no": "4.1",
                "policy": "To enhance Türkiye’s integration into global value chains, the level of compliance with international trade policies in green and digital transformation areas will be increased."
            },
            {
                "policy_no": "4.2",
                "policy": "Considering economic developments in Türkiye and global trade, efforts will be made to update the existing Customs Union and free trade agreements and new trade agreements for target countries will be negotiated."
            },
            {
                "policy_no": "4.3",
                "policy": "To strengthen Türkiye’s position in global value chains, logistics capabilities across all modes of transportation will be further developed."
            },
            {
                "policy_no": "4.4",
                "policy": "Collaboration between existing international investors in Türkiye and local supplier firms will be further enhanced to increase the integration of local firms into global value chains."
            },
            {
                "policy_no": "4.5",
                "policy": "To improve efficiency and effectiveness in customs procedures, information and communication technologies will be adopted at maximum level and customs services will be transformed to align with green and digital transitions."
            },
            {
                "policy_no": "4.6",
                "policy": "Actions will be taken to increase the share of quality service inputs such as R&D, design, supply chain management, distribution, and maintenance in the manufacturing sector to enhance added value in the country."
            },
            {
                "policy_no": "5.1",
                "policy": "Development of the skilled human capital needed by Türkiye in the framework of its twin transformation will be ensured, and legislative works compatible with new working models emerging from future professions will be conducted and existing human capital will be equipped with skills for the future."
            },
            {
                "policy_no": "5.2",
                "policy": "Programs will be developed to increase education and employment in the fields of STEM (mathematics, science, technology, and engineering) and to increase the availability of competent R&D personnel required by quality FDI profiles."
            },
            {
                "policy_no": "5.3",
                "policy": "Efforts will be made to improve the industry-specific foreign language skills of the human resources needed by quality FDI profiles."
            },
            {
                "policy_no": "5.4",
                "policy": "To train the technical human resources required by quality FDI profiles, efforts will be made to enhance the quality of vocational education, and to facilitate the transition of individuals trained in vocational and technical education into the labor market."
            },
            {
                "policy_no": "5.5",
                "policy": "Targeted efforts will be conducted to attract qualified human resources from abroad to the country and to retain existing talents."
            },
            {
                "policy_no": "5.6",
                "policy": "Initiatives will be undertaken to encourage the participation in the workforce of segments currently not in the labor force, focusing especially on women and youth, to activate them in the economy."
            },
            {
                "policy_no": "6.1",
                "policy": "By adopting a 360-degree communication approach, Türkiye’s investment environment will be actively promoted through tools such as investment diplomacy, international campaigns, and media relations etc."
            },
            {
                "policy_no": "6.2",
                "policy": "Efforts will be made to strengthen the “Invest in Türkiye” brand and to develop and communicate effective messages to target audiences in line with the “Türkiye Century, Century of Investments” vision."
            },
            {
                "policy_no": "6.3",
                "policy": "Promotional activities will be carried out in priority sectors through customized content, materials, target audience-oriented events and digital campaigns promoting investment opportunities of the country."
            },
            {
                "policy_no": "6.4",
                "policy": "Target investors in line with the quality FDI profiles will be determined and lead generation activities will be carried out for these investors."
            },
            {
                "policy_no": "6.5",
                "policy": "Türkiye’s communication and promotional activities will be strengthened by developing collaborations with all national and international stakeholders within the framework of strategic communication."
            }
        ],
        "policy_areas": [
            {
                "area_no": "1",
                "policy_area": "Investment Climate and Competitiveness",
                "imgSrc": "/images/66b262cebe6aa1fd8866d805_qualified_investment.png"
            },
            {
                "area_no": "2",
                "policy_area": "Green Transformation",
                "imgSrc": "/images/66b262e1378812f97c95e929_05.png"
            },
            {
                "area_no": "3",
                "policy_area": "Digital Transformation",
                "imgSrc": "/images/66b262f88aeec805f8c89cee_08.png"
            },
            {
                "area_no": "4",
                "policy_area": "Global Value Chains (GVCs)",
                "imgSrc": "/images/66b263055dc4a30bfe69fee9_01.png"
            },
            {
                "area_no": "5",
                "policy_area": "Talent Pool",
                "imgSrc": "/images/66b2631df1f52b5ef87174d1_new-centers2.png"
            },
            {
                "area_no": "6",
                "policy_area": "Communication & Promotion",
                "imgSrc": "/images/66b263d68aeec805f8c937fb_Communications%20Promo%20Icon.png"
            }
        ]
    },
    "headerMenu": {
        "currentLanguage": {
            "code": "EN",
            "icon": ""
        },
        "optionalLanguages": [
            {
                "code": "TR",
                "label": "Turkish",
                "icon": "",
                "link": "/tr"
            }
        ],
        "menuItems": [
            {
                "name": "HOME",
                "link": "/",
                "icon": null
            },
            {
                "name": "FDI INSIGHTS",
                "link": "/insights",
                "icon": null
            },
            {
                "name": "ACTION PLAN",
                "link": "/action-plans",
                "icon": null
            }
        ],
        "mobileMenuButton": {
            "icon": "",
            "label": "Menu"
        },
        "downloadButton": {
            "text": "Download PDF",
            "link": "https://www.invest.gov.tr/en/Documents/national-fdi-strategy-action-plan-2026.pdf",
            "icon": ""
        }
    },
    "form": {
        "placeholder": "Your email address..",
        "submitText": "Get Started",
        "successMessage": "Your request has been successfully submitted.",
        "errorMessage": "There was an issue submitting your form. Please try again."
    },
    "footerMenu": {
        "logoLink": "/",
        "downloadPdf": {
            "text": "Download PDF",
            "link": "https://www.invest.gov.tr/en/library/publications/lists/investpublications/turkiye-foreign-direct-investment-strategy-2024-2028.pdf",
            "icon": ""
        },
        "menuItems": [
            {
                "title": "HOME",
                "link": "/"
            },
            {
                "title": "FDI INSIGHTS",
                "link": "/insights",
                "subLinks": [
                    {
                        "title": "FDI Outlook & Trends",
                        "link": "/insights#fdi-outlook"
                    },
                    {
                        "title": "Performance & Ecosystem",
                        "link": "/insights#fdi-performance"
                    },
                    {
                        "title": "Key Findings",
                        "link": "/insights#key-findings"
                    },
                    {
                        "title": "Quality FDI",
                        "link": "/insights#quality-fdi"
                    }
                ]
            }
        ],
        "actionPlan": {
            "title": "ACTION PLAN",
            "link": "/action-plans"
        }
    }
}